import { useLazyQuery, useMutation, useQuery } from '@apollo/client';
import { useDispatch, useSelector } from 'react-redux';
import * as entities from '../../../graphql/entities';
import { CustomerAttributeConfig, Payment, SalesOrder, SalesOrderLine } from '../../../graphql/entities';
import React, {
  ComponentProps,
  Fragment,
  ReactElement,
  Suspense,
  useCallback,
  useContext,
  useEffect,
  useMemo,
  useRef,
  useState,
} from 'react';
import getIn from '../../../components/connectedForm/utils/getIn';
import setIn from '../../../components/connectedForm/utils/setIn';
import { default as Form } from '../../../components/connectedForm';
import Formatters from '../../../components/grid-addons/formatters';
import EditableDataGrid from '../../../components/EditableDataGrid';
import mapStateToFormProps from '../../../utils/mapStateToFormProps';
import InputBlock from '../../../components/connectedForm/InputBlock';
import InputGroup from '../../../components/connectedForm/InputGroup';
import InputLabel from '../../../components/connectedForm/InputLabel';
import createForm from '../../../components/connectedForm/ConnectedForm';
import * as input from '../../../components/connectedForm/inputComponents';
import StockTotalQuery from '../../../graphql/queries/product/StockTotalQuery.graphql';
import { SalesOrderAlternativeProductsModal } from '../../../components/modals/AlternativeProductModal/AlternativeProductModal';
import OrderTotals from '../../../components/CommonOrderComponents/OrderTotals';
import ValueBreakdown from '../../../components/CommonOrderComponents/ValueBreakdown';
import LineDetailsPanel from '../../../components/CommonOrderComponents/LineDetailsPanel';
import SortableDataGrid from '../../../components/EditableDataGrid/SortableDataGrid';
//Audit Tab
import GridContainer from '../../../components/connectedForm/GridContainer';
import AuditByFieldWorkspace from '../../company/AuditByFieldWorkspace';
//Modal
import ColumnLabel from '../../../components/connectedForm/ColumnLabel/ColumnLabel';
import Label from '../../../components/connectedForm/Label/Label';
import SalesOrderHeader from '../../../components/SalesOrderHeader/SalesOrderHeaderComponent';
import DeliveryInstructionsTab from '../../customer/DeliveryInstructionsTab';
import DocumentModal2 from '../../../components/modals/DocumentModal2';
import { InfoButton } from '../../../components/connectedForm/Button';
import RecalculatePricingModal from '../../../components/modals/RecalculatePricingModal';
import { checkPermission } from '../../../utils/OperationPermissions';
import { getCount } from '../../../utils/CountUtil';
import { serviceActions } from '../../../state/modules/service';
import ConnectedFormContext from '../../../components/Context/ConnectedFormContext';
import { getPriceBands } from '../../../utils/PriceBandsUtil';
import { SalesOrderProductSaveModal } from '../../../components/ProductFormModal';
import fieldMetaData from '../../../graphql/schema/fieldMetaData';
import { getSalesOrderStatusIcon } from '../../../utils/SalesUtils';
import DocumentSummaryWorkspace from '../../company/DocumentSummaryWorkspace';
import {
  useCompany,
  useCustomerConfig,
  useDocumentConfig,
  useProductConfig,
  useSalesOrderConfig,
} from '../../../utils/FetchConfig';
import AppContext from '../../../components/Context/AppContext';
import { useProductFromLuckinsItemState, useSpecialOrderProductState } from '../../../utils/SalesOrderHooks';
import { AddressInfo } from '../../../components/CommonOrderComponents/AddressInfo';
import {
  normalizeOrderLines,
  useSalesEntryGridWithRowUpdated,
} from '../../../components/CommonOrderComponents/CommonOrderFunctions';
import CheckboxEditor from '../../../components/CheckboxInputEditor/CheckboxInputEditor';
import SalesCreditFormModal from '../../../components/modals/SalesCreditFormModal';
import { ProgressIndicator } from '@fluentui/react/lib/ProgressIndicator';
import SalesOrderContext, { SalesOrderContextType } from '../../../components/Context/SalesOrderContext';
import CurrencyContext from '../../../components/Context/CurrencyContext';
import { getIdFromPropsForFilter } from '../../../utils/formUtils';
import SalesOrderLineItemInformationQuery from '../../../graphql/queries/sales/SalesOrderLineItemInformation.graphql';
import { useFormQuery } from '../../../graphql/containers/useFormQuery';
import FluentTextField, { IFluentTextFieldProps } from '../../../components/FluentWrapper/FluentTextField';
import { ConnectedFormPristinePrompt } from '../../../components/connectedForm/ConnectedFormPristinePrompt';
import {
  ActionType,
  AlertType,
  AlternativeProductType,
  CarriageCalculationMethod,
  CostViewPermission,
  DocumentType,
  FilterOperation,
  ICustomer,
  ICustomerNotesQueryResult,
  ICustomerNotesQueryVariables,
  IFilterInput,
  ILuckinsItem,
  IPaymentLine,
  IProduct,
  IRefundLine,
  ISalesNotesQueryResult,
  ISalesNotesQueryVariables,
  ISalesOrder,
  ISalesOrderLine,
  ISalesOrderSummary,
  IStockTotalQueryResult,
  IStockTotalQueryVariables,
  LineActionRequired,
  Maybe,
  OrderType,
  PriceSelectionPermission,
  ProductClass,
  SalesOrderActivationType,
  SalesOrderLineStatus,
  SalesOrderPromptBehaviour,
  ShortageProcessedState,
} from '../../../graphql/schema/p4types';
import TraceabilityDetails from '../TraceabilityDetails';
import CommentRowContext from '../../../components/Context/CommentRowContext';
import InvoiceDocumentsOrderGrid from '../../company/InvoiceDocumentsOrderGrid';
import SalesOrderItemGrid from './SalesOrderItemGrid';
import LineDetailsInvoices from './LineDetailsInvoices';
import { submitSalesOrderValues } from './salesOrderFormUtils';
import instanceByAllocationQuery from '../../../graphql/queries/sales/SalesOrderByAllocationQuery.graphql';
import BlurTextField, {
  BlurTextFieldType,
  HrefLink,
  IBlurTextFieldProps,
} from '../../../components/connectedForm/BlurTextField/BlurTextField';
import { IDropdownProps } from '../../../@types/dropdown';
import { IAttributeArrayProps } from '../../../components/connectedForm/AttributeArray';
import { IGridUploaderProps } from '../../../components/connectedForm/GridUploader';
import {
  IEditableDataGridProps,
  IOnCellSelectedFunction,
  IRowUpdatedFunction,
} from '../../../components/EditableDataGrid/EditableDataGrid';
import { EntityType } from '../../../@types/entityTypes';
import { ICommit } from '../../../@types/editableDataGridTypes';
import { originStatuses } from '../OriginStatuses';
import { usePriceSelectionPermission } from '../../salesLedger/tradeCounter/hooks';
import SalesOrderPaymentModal from '../../../components/modals/SalesOrderPaymentModal';
import ModalContext from '../../../components/Context/ModalContext';
import UserContext from '../../../components/Context/UserContext';
import { IDateFieldProps } from '../../../components/connectedForm/DateInput/DateInput';
import { IExtendedMetaAction, useSalesOrderPostSave } from './useSalesOrderPostSave';
import MemoEditor, {
  IMemoEditorType,
  useMemoEditorProps,
} from '../../../components/connectedForm/MemoEditor/MemoEditor';
import CustomerNotesWorkspaceQuery from '../../../graphql/queries/customer/CustomerNotesWorkspaceQuery.graphql';
import SalesNotesWorkspaceQuery from '../../../graphql/queries/sales/SalesNotesWorkspaceQuery.graphql';
import SalesNoteType from '../../../graphql/entities/sales/SalesNoteType';
import CustomerNoteType from '../../../graphql/entities/customer/CustomerNoteType';
import useEntityCacheUpdate from '../../../graphql/hooks/useEntityCacheUpdate';
import { TrackingDetailsForDispatchInstruction } from './TrackingDetails';
import { round, RoundingModes } from '../../../utils/NumberUtils';
import MaxoptraTab from './MaxoptraTab';
import ProformaPayByLinksQuery from '../../../graphql/queries/sales/ProformaPayByLinksQuery.graphql';
import { AbstractLineGrid } from '../../../components/EditableDataGrid/AbstractLineGrid';
import { usePurchaseOrderPrintOnSuccess } from './usePurchaseOrderPrintOnSuccess';
import { useCookies } from 'react-cookie';
import { add, addDays, format, isAfter, parseISO } from 'date-fns';
import Legend from '../../../components/connectedForm/Legend';
import { DeliveryLookupField } from './DeliveryLookupField';
import { IReduxStore } from '../../../@types/reduxTypes';
import { Divider, makeStyles } from '@fluentui/react-components';
import { ICheckboxInputProps } from '../../../components/connectedForm/CheckboxInput/CheckboxInput';
import { ConnectedAddress } from '../../../components/connectedForm/ConnectedAddress';
import { SalesOrderStatusCellFormatter } from '../../../components/CellFormatters/SalesOrderStatusCellFormatter';
import { IStatusFlag } from '../../../components/connectedForm/HeaderBlock/HeaderBlock';
import { StatusStyle } from '../../../components/connectedForm/HeaderStatus';
import { BasicConfirmation } from '../../../components/modals/ConfirmationPrompt';
import { change } from '../../../components/connectedForm/utils/actions';
import useSalesOrderLineContextActions from './useSalesOrderLineContextActions';
import { cloneDeep } from '@apollo/client/utilities';
import useInstrastatHints from '../../../utils/useInstrastatHints';
import useEditableDataGridViewController from '../../../components/view/UseEditableDataGridViewController';
import { ICommentRowRendererProps } from '../../../components/EditableDataGrid/CommentRowRenderer';
import { useSalesOrderLineColumns } from './useSalesOrderLineColumns';
import { useFullUserDetails } from '../../../utils/hooks';
import { FinancialTransactionModalFormatter } from '../../../components/modals/FinancialTransactionModal';
import { CustomerGlobalContactLookupIcon } from '../../../components/modals/CustomerGlobalContactLookup';
import CustomerContact from '../../../graphql/entities/customer/CustomerContact';

const AnyCheckboxEditor = CheckboxEditor as any;

const HIDE_INVOICED_LINE_ITEMS_COOKIE = 'HIDE_INVOICED_LINE_ITEMS_COOKIE';

const LazyCommentRowRenderer = React.lazy(() => import('../../../components/EditableDataGrid/CommentRowRenderer'));
const LazySalesOrderWorkspace = React.lazy(() => import('../../../views/sales/SalesOrderWorkspace'));
const LazySalesOrderLineWorkspace = React.lazy(() => import('../../../views/sales/SalesOrderLineWorkspace'));
const LazyDiaryEventWorkspace = React.lazy(() => import('../../../views/diary/DiaryEventWorkspace'));

const SalesOrderRowRenderer = (props: ICommentRowRendererProps) => {
  const [cookies] = useCookies([HIDE_INVOICED_LINE_ITEMS_COOKIE]);

  const shouldHideRow =
    cookies.HIDE_INVOICED_LINE_ITEMS_COOKIE === 'true' &&
    props.row.salesOrderLineStatus?.length === 1 &&
    props.row.salesOrderLineStatus[0] === SalesOrderLineStatus.Invoiced;

  if (shouldHideRow) {
    return null;
  }

  return <LazyCommentRowRenderer {...props} />;
};

// Expected state values when navigating to the Sales Order Form.
type ISalesOrderLocationState = {
  defaultValues?: Array<{ field: 'orderType' | 'templated' | 'customerId'; value: any }>;
  duplicateId?: number;
};

const useStyles = makeStyles({
  divider: {
    paddingTop: '5px',
    paddingBottom: '5px',
  },
});

const defineStockTotalQueryVariables: (
  selectedRow: ISalesOrderLine,
  defaultWarehouseId?: number
) => IStockTotalQueryVariables = (selectedRow, defaultWarehouseId) => {
  return {
    productId: selectedRow.product?.id ?? null,
    warehouseId: selectedRow.warehouse?.id ?? defaultWarehouseId ?? null,
  };
};

const DISPATCH_COLUMN_META = [
  {
    name: 'Order Number',
    key: 'salesOrder.orderNumber',
    editable: false,
  },
  {
    name: 'Document Number',
    key: 'documentNumber',
    editable: false,
  },
  {
    name: 'Document Suffix',
    key: 'documentSuffix',
    editable: false,
  },
  {
    name: 'Dispatch Date',
    key: 'dispatchDate',
    editable: false,
  },
  {
    name: 'Carrier',
    key: 'deliveryMethod.carrier.name',
    editable: false,
  },
  {
    name: 'Delivery Method',
    key: 'deliveryMethod.description',
    editable: false,
  },
  {
    name: 'Consignment Reference',
    key: 'consignmentReference',
    editable: false,
  },
  {
    name: 'Carrier Reference',
    key: 'carrierReference',
    editable: false,
  },
  {
    name: 'Net Product Weight',
    key: 'weight',
    editable: false,
  },
  {
    name: 'Packaging Weight',
    key: 'packagingWeight',
    editable: false,
  },
  {
    name: 'Cancelled',
    key: 'cancelled',
    editable: false,
    formatter: Formatters.BooleanFormatter,
  },
];

const DISPATCH_DETAIL_FIELD_NAMES = [
  'product.reference',
  'description',
  'quantity',
  'assigned',
  'allocated',
  'productionRequired',
  'inProduction',
  'dispatched',
  'invoiced',
  'returned',
  'freeStock',
];

const EXCHANGE_COLUMN_META = [
  {
    name: 'Number',
    key: 'documentNumber',
    editable: false,
    formatter: FinancialTransactionModalFormatter,
    options: {
      entityId: 'id',
      documentType: DocumentType.SalesCredit,
    },
  },
  {
    name: 'Date',
    key: 'documentDate',
    formatter: Formatters.DateFormatter,
  },
  {
    name: 'Credit Total',
    key: 'headerTotal',
    formatter: Formatters.NumericFormatter,
    options: {
      format: { decimals: 2 },
    },
  },
  {
    key: 'documentStatus',
    name: 'Status',
    formatter: Formatters.DocumentStatusFormatter,
  },
  {
    name: 'Invoice Number',
    key: 'salesInvoice.documentNumber',
    editable: false,
    formatter: FinancialTransactionModalFormatter,
    options: {
      entityPath: 'salesInvoice',
      entityId: 'id',
      documentType: DocumentType.SalesInvoice,
    },
  },
];

const dataStoreId = 'haggleWindow';

const ORDER_TYPE_OPTIONS = [
  {
    value: 'QUOTE',
    label: 'Quote',
  },
  {
    value: 'ORDER',
    label: 'Order',
  },
];

const useSalesOrderIdPredefinedFilters = (id: number | 'New') => {
  if (id && id !== 'New') {
    return {
      salesOrderAuditPredefinedFilters: [
        {
          filterOperation: 'EQUALS',
          filterParameters: {
            field: 'id',
            value: id,
          },
        },
      ],
      eventPredefinedFilters: [
        {
          filterOperation: 'EQUALS',
          filterParameters: {
            field: 'salesOrder.id',
            value: id,
          },
        },
      ],
    };
  }
  return {
    eventPredefinedFilters: [
      {
        filterOperation: 'EQUALS',
        filterParameters: {
          field: 'salesOrder.id',
          value: 0,
        },
      },
    ],
  };
};

const SALES_ORDER_STATUS_FLAGS: Array<IStatusFlag> = [
  {
    key: 'vatInclusive',
    status: [
      {
        value: true,
        style: StatusStyle.Info,
        title: 'VAT Inclusive',
        icon: 'queue',
      },
    ],
  },
  {
    key: 'customer.customerAccountStatus.onStop',
    status: [
      {
        value: true,
        style: StatusStyle.Danger,
        title: 'Customer On Stop',
        icon: 'pause_circle_outline',
      },
    ],
  },
  {
    key: 'foreignCurrency',
    status: [
      {
        value: true,
        style: StatusStyle.Info,
        icon: 'account_balance',
        titleKey: 'currency.isoCode.codeAlpha3',
      },
    ],
  },
  {
    key: 'held',
    status: [
      {
        value: true,
        style: StatusStyle.Warning,
        title: 'Held',
        icon: 'pause',
      },
    ],
  },
  {
    key: 'archived',
    status: [
      {
        value: true,
        style: StatusStyle.Danger,
        title: 'Archived',
        icon: 'save',
      },
    ],
  },
  {
    key: 'orderOrigin',
    status: originStatuses,
  },
  {
    key: 'salesOrderStatus',
    status: fieldMetaData.SalesOrderLineStatus.enumValues.map((entry) => {
      const icon = getSalesOrderStatusIcon(entry.value);
      return {
        value: entry.value,
        title: entry.label,
        style: icon.color,
        icon: icon.type,
        tooltip: icon.tooltip,
      };
    }),
  },
  {
    key: 'cashStatus',
    status: [
      {
        value: 'PRO_FORMA',
        style: StatusStyle.Info,
        title: 'Pro forma',
      },
    ],
  },
  {
    key: 'draft',
    status: [
      {
        value: true,
        style: StatusStyle.Basic,
        title: 'Draft',
      },
    ],
  },
  {
    key: 'hasMaxoptraOrder',
    status: [
      {
        value: true,
        style: StatusStyle.Info,
        title: 'Maxoptra',
      },
    ],
  },
  {
    key: 'exportedToEdi',
    status: [
      {
        value: true,
        style: 'info',
        icon: 'import_export',
        title: 'Exported to EDI',
      },
    ],
  },
];

const useValidateDispatchGroupCode = () => {
  return useCallback((commit: ICommit<ISalesOrderLine>) => {
    if (commit && commit.cellKey === 'dispatchGroupCode') {
      const enteredValue = commit.updated?.dispatchGroupCode;
      commit.updated!.dispatchGroupCode =
        enteredValue
          ?.replace(/[^\w\s]/gi, '')
          .toUpperCase()
          .slice(0, 5) ?? null;
    }
  }, []);
};

const useBatchAllocationWithRowUpdated = () => {
  const prevCommit = useRef<any>();
  const batchAllocationPromptBehaviour: Maybe<SalesOrderPromptBehaviour> = useSelector(
    (store: IReduxStore) =>
      store?.app?.fullUserDetails?.companyUser?.companyUserSalesOptions?.batchAllocationPromptBehaviour
  );

  return useCallback(
    (commit: ICommit<ISalesOrderLine>) => {
      if (batchAllocationPromptBehaviour !== SalesOrderPromptBehaviour.Disabled) {
        const { original, ...sans } = commit;
        prevCommit.current = sans;
        const productBatchAllocationOriginal = commit.original?.product?.batchAllocation;
        const productBatchAllocationUpdated = commit.updated?.product?.batchAllocation;

        const productBatchAllocation =
          productBatchAllocationUpdated !== undefined ? productBatchAllocationUpdated : productBatchAllocationOriginal;

        let setBatchAllocationRequired: boolean | null | undefined;
        if (productBatchAllocationUpdated && !productBatchAllocationOriginal) {
          //Selected a Product with the batchAllocation flag - Trigger the batch allocation modal.
          setBatchAllocationRequired = true;
        } else {
          const quantityCellKey = commit.cellKey === 'quantity' || commit.cellKeys?.some((key) => key === 'quantity');
          const quantityChanged = quantityCellKey && parseFloat(commit.updated?.quantity) !== commit.original?.quantity;

          //If this is a batch allocation product & the quantity has changed,
          setBatchAllocationRequired =
            productBatchAllocation &&
            quantityChanged &&
            commit.original?.batchAllocationRequired !== LineActionRequired.None;
        }

        if (setBatchAllocationRequired) {
          if (!commit.cellKeys) commit.cellKeys = [commit.cellKey];
          //Changing the LineActionRequired field will trigger batch allocation via an effect
          commit.cellKeys.push('batchAllocationRequired');
          commit.updated!.batchAllocationRequired =
            batchAllocationPromptBehaviour === SalesOrderPromptBehaviour.PromptOnSaveAndLineEntry
              ? LineActionRequired.Any
              : LineActionRequired.AfterSave;
        }
      }
    },
    [batchAllocationPromptBehaviour]
  );
};

const useShortageWithRowUpdated = (): ((commit: ICommit<ISalesOrderLine>) => void) => {
  const connectedForm = useContext(ConnectedFormContext);
  const values = connectedForm.values as ISalesOrder;

  return useCallback(
    (commit: ICommit<ISalesOrderLine>) => {
      //Fallback to warehouse for the order when not set.
      const originalWarehouseId = commit.original?.warehouse?.id ?? values.warehouse?.id;
      const newWarehouseId = commit.updated?.warehouse?.id ?? values.warehouse?.id;

      const quantityChanged =
        commit.cellKeys.includes('quantity') &&
        parseFloat(commit.original?.quantity) !== parseFloat(commit.updated?.quantity);
      const productChanged =
        commit.cellKeys.includes('product.id') && commit.original?.product?.id !== commit.updated?.product?.id;
      const warehouseChanged = commit.cellKeys.includes('warehouseId') && originalWarehouseId !== newWarehouseId;

      if (quantityChanged || productChanged || warehouseChanged) {
        commit.cellKeys.push('shortageProcessedState');
        commit.updated!.shortageProcessedState = ShortageProcessedState.Required;
      }
    },
    [values.warehouse?.id]
  );
};

const useSalesOrderOnRowUpdated = (
  alternateProductModalOpen: boolean,
  checkShortageOrAlternateModal: (commit: ICommit<ISalesOrderLine>) => void,
  createProductFromLuckinsItem: ReturnType<typeof useProductFromLuckinsItemState>['createProductFromLuckinsItem'],
  createSpecialOrderProduct: ReturnType<typeof useSpecialOrderProductState>['createSpecialOrderProduct']
) => {
  const dispatch = useDispatch();
  return useCallback(
    (commit: ICommit<ISalesOrderLine>) => {
      const { cellKey, cellKeys, updated, rowIdx } = commit;
      //Should not do additional processing for archived lines.
      //Don't trigger any further state changes from the grid while the alternate product modal is open.
      //If any field other than product, warehouse or quantity changed, ignore it.
      if (updated?.archived || alternateProductModalOpen) {
        return;
      }
      if (!(cellKeys.includes('product') || cellKeys.includes('warehouse') || cellKeys.includes('quantity'))) {
        return;
      }

      if ((updated?.product as IProduct | ILuckinsItem)?.__typename === 'LuckinsItem') {
        const luckinsItem = updated?.product as ILuckinsItem;
        createProductFromLuckinsItem(luckinsItem.id, rowIdx);
        //Clear the product from the line as it's invalid and temporary saves will throw errors otherwise!
        updated!.product = null;
        //Don't want to trigger any other processing now that we've cleared the selected item.
        return;
      }

      // if selected product is a special order template, generate a new product and display the (mini) product form.
      if (updated?.product?.template && updated?.product.specialOrder) {
        createSpecialOrderProduct(updated?.product.id, rowIdx);
        return;
      }

      if (
        cellKey === 'product' &&
        (updated?.product?.supersessions?.filter?.((entry) => entry?.type !== AlternativeProductType.Supersession)
          ?.length ?? 0) > 0
      ) {
        dispatch(
          serviceActions.genericAlert('Suggested Products', 'Alternative/Upsell products available.', AlertType.Info)
        );
      }
      checkShortageOrAlternateModal(commit);
    },
    [
      alternateProductModalOpen,
      checkShortageOrAlternateModal,
      createProductFromLuckinsItem,
      createSpecialOrderProduct,
      dispatch,
    ]
  );
};

/**
 * Behaviours when a line is updated and the order type is QUOTE
 */
const useQuoteLineWithRowUpdated = () => {
  const orderConfig = useSalesOrderConfig();
  const connectedForm = useContext(ConnectedFormContext);
  const isQuote = connectedForm.values?.orderType === OrderType.Quote;

  return useCallback<IRowUpdatedFunction<ISalesOrderLine>>(() => {
    if (!isQuote) {
      return;
    }

    // If automaticExpiryUpdate is enabled, and the calculated expiry date is after the current expiry date, update it when a line is changed.
    const expiryDate = connectedForm.values?.expiryDate && parseISO(connectedForm.values?.expiryDate);
    if (
      orderConfig?.quoteExpiryDays !== undefined &&
      orderConfig.quoteExpiryDays !== null &&
      orderConfig.automaticExpiryUpdate
    ) {
      const recalculatedDays = addDays(new Date(), orderConfig.quoteExpiryDays);
      if (!expiryDate || isAfter(recalculatedDays, expiryDate)) {
        connectedForm.change('expiryDate', format(recalculatedDays, 'yyyy-MM-dd'));
      }
    }
  }, [isQuote, connectedForm, orderConfig]);
};

const SalesOrderForm = (props: any) => {
  const selectedRow = useRef<Maybe<ISalesOrderLine>>(null);
  const dispatch = useDispatch();
  const connectedForm = useContext(ConnectedFormContext);
  const fullUserDetails = useFullUserDetails();

  const values = props.values as ISalesOrder;
  const addModalActions = props.addModalActions;

  const [selectedDispatchRow, setSelectedDispatchRow] = useState(null);
  const [lineDetailsSelected, setLineDetailsSelected] = useState<Maybe<ISalesOrderLine>>({} as ISalesOrderLine);
  const [addCommentToRow, setAddCommentToRow] = useState<Maybe<number>>(null);
  const [showRecalculateModal, setShowRecalculateModal] = useState(
    !!(props.location?.state as ISalesOrderLocationState)?.duplicateId
  );
  const [previousRowIdx, setPreviousRowIdx] = useState<Maybe<number>>();
  const [rowIdx, setRowIdx] = useState<Maybe<number>>();
  const [colIdx, setColIdx] = useState<Maybe<number>>();
  const [active, setActive] = useState<string | undefined>();
  const [addedRowIndices, setAddedRowIndices] = useState<Set<number>>(new Set());
  const [salesOrderArchivedAndAmazon, setSalesOrderArchivedAndAmazon] = useState<boolean>(false);
  const [unprocessedLines, setUnprocessedLines] = useState<number[]>([]);
  const [paymentReprintModalOpen, setPaymentReprintModalOpen] = useState(false);
  const [cookies, setCookie] = useCookies([HIDE_INVOICED_LINE_ITEMS_COOKIE]);

  const { data: payByLinks } = useQuery<{ data: string[] }, { salesOrderId: number }>(ProformaPayByLinksQuery, {
    variables: {
      salesOrderId: props?.values?.id,
    },
    skip: !props?.values?.id || !fullUserDetails?.flags?.motoPaymentsEnabled,
  });

  useEffect(() => {
    if (props.values.archived && props.values.orderOrigin.includes('AMAZON')) {
      setSalesOrderArchivedAndAmazon(true);
    }
  }, [props.values.archived, props.values.orderOrigin]);

  const orderConfig = useSalesOrderConfig();

  const id = getIn(props, 'match.params.id');
  const { salesOrderAuditPredefinedFilters, eventPredefinedFilters } = useSalesOrderIdPredefinedFilters(id);

  // let baseCurrency;
  let currencyCode: Maybe<string>;
  const foreignCurrency = props.values?.foreignCurrency;
  if (foreignCurrency) {
    currencyCode = props.values.currency?.isoCode?.codeAlpha3;
    // baseCurrency = props.values.baseCurrency?.isoCode?.codeAlpha3;
  } else {
    currencyCode = null;
  }

  const itemTableHeight = Math.max(window.innerHeight - 620, 175);

  const onCellSelected: IOnCellSelectedFunction = (dataid: string, selected: { idx: number; rowIdx: number }) => {
    const active = selected.idx > 2 ? 'haggle' : 'info';

    setPreviousRowIdx(rowIdx);
    setRowIdx(selected.rowIdx);
    setColIdx(selected.idx);
    setActive(active);
  };

  const definePaymentHistoryColumnMeta = () => {
    return [
      {
        name: 'Payment Method',
        key: 'paymentMethod.description',
        editable: false,
        resizable: true,
      },
      {
        name: 'Bank Account',
        key: 'bankAccount.description',
        editable: false,
        resizable: true,
      },
      {
        name: 'Amount',
        key: 'paymentValue',
        editable: false,
        resizable: true,
      },
      {
        name: 'Printed',
        key: 'paymentPrinted',
        editable: false,
        resizable: true,
        formatter: Formatters.BooleanFormatter,
      },
      {
        name: 'Receipt/Refund Date',
        key: 'receiptDate',
        editable: false,
        resizable: true,
        formatter: Formatters.DateFormatter,
      },
      {
        name: 'Created At',
        key: 'createdAt',
        editable: false,
        resizable: true,
        formatter: Formatters.DateTimeFormatter,
      },
      {
        name: 'Created By',
        key: 'createdBy',
        editable: false,
        resizable: true,
      },
    ];
  };

  /**
   * This function is called directly after 'withRowUpdated' with the same commit object.
   * @param commit - Wrapper for the commit with details of previous/new values & which keys have been modified.
   */
  const onRowUpdated = (commit: ICommit<ISalesOrderLine>) => {
    if (commit.original) {
      let updatedRow = commit.original;
      commit.cellKeys.forEach((cellKey) => {
        updatedRow = setIn(updatedRow, cellKey, commit.updated?.[cellKey as keyof ISalesOrderLine]);
      });
      selectedRow.current = updatedRow;
    } else {
      selectedRow.current = commit.updated as ISalesOrderLine;
    }

    props.onRowUpdated?.({
      cellKey: commit.cellKey,
      cellKeys: commit.cellKeys,
      updated: selectedRow.current,
      original: commit.original,
      rowIdx: commit.rowIdx,
    });
  };

  const onRowClick = (clickedRowIdx: number) => {
    if ((previousRowIdx ?? -1) >= 0 && previousRowIdx !== clickedRowIdx) {
      const previousLine = props.values.orderLines?.[previousRowIdx as number];
      if (previousLine && previousLine.product && previousLine.quantity) {
        //Mock that we've 'touched' the quantity field to trigger shortage logic if navigating to another row.
        const mockCommit = {
          cellKey: 'quantity',
          cellKeys: ['quantity'],
          original: previousLine,
          updated: previousLine,
          rowIdx: previousRowIdx!,
        };
        onRowUpdated(mockCommit);
        //If the onRowUpdated function has set a processed state, we need to actually trigger an update (Not just mock the run-through).
        //Otherwise, the modal will constantly be redisplayed whenever you navigate around the grid.
        if (mockCommit.cellKeys.includes('shortageProcessedState')) {
          dispatch(
            connectedForm.change(
              `orderLines.${previousRowIdx}.shortageProcessedState`,
              mockCommit.updated?.shortageProcessedState
            )
          );
        }
      }
    }
  };

  const updateDeliveryAddress = (resetFields: boolean) => {
    if (resetFields) {
      connectedForm.change('customerContact', null);
      connectedForm.change('deliveryName', '');
      connectedForm.change('deliveryAddress.line1', 'N/A');
      connectedForm.change('deliveryAddress.line2', '');
      connectedForm.change('deliveryAddress.line3', '');
      connectedForm.change('deliveryAddress.line4', '');
      connectedForm.change('deliveryAddress.line5', '');
      connectedForm.change('deliveryAddress.postCode', '');
      connectedForm.change('deliveryAddress.what3words', '');
    } else {
      connectedForm.change('deliveryName', values.invoiceCompany);
      connectedForm.change('deliveryAddress.line1', values.invoiceAddress?.line1);
      connectedForm.change('deliveryAddress.line2', values.invoiceAddress?.line2);
      connectedForm.change('deliveryAddress.line3', values.invoiceAddress?.line3);
      connectedForm.change('deliveryAddress.line4', values.invoiceAddress?.line4);
      connectedForm.change('deliveryAddress.line5', values.invoiceAddress?.line5);
      connectedForm.change('deliveryAddress.postCode', values.invoiceAddress?.postCode);
      connectedForm.change('deliveryAddress.what3words', values.invoiceAddress?.what3words);
    }
  };
  //</editor-fold>

  const getExcludedDeliveryDays = () => {
    const deliveryInstruction = getIn(props.values, 'customer.deliveryInstruction');
    const deliveryMethod = getIn(props.values, 'deliveryMethod');
    const excludeDays: Array<number> = [];
    if (deliveryInstruction || deliveryMethod) {
      if (deliveryInstruction?.noDeliveriesSunday || deliveryMethod?.noDeliveriesSunday) excludeDays.push(0);
      if (deliveryInstruction?.noDeliveriesMonday || deliveryMethod?.noDeliveriesMonday) excludeDays.push(1);
      if (deliveryInstruction?.noDeliveriesTuesday || deliveryMethod?.noDeliveriesTuesday) excludeDays.push(2);
      if (deliveryInstruction?.noDeliveriesWednesday || deliveryMethod?.noDeliveriesWednesday) excludeDays.push(3);
      if (deliveryInstruction?.noDeliveriesThursday || deliveryMethod?.noDeliveriesThursday) excludeDays.push(4);
      if (deliveryInstruction?.noDeliveriesFriday || deliveryMethod?.noDeliveriesFriday) excludeDays.push(5);
      if (deliveryInstruction?.noDeliveriesSaturday || deliveryMethod?.noDeliveriesSaturday) excludeDays.push(6);
    }

    return excludeDays;
  };

  //When
  useEffect(() => {
    const shouldAddAction =
      values.orderLines?.some((v) => v!.batchAllocationRequired === LineActionRequired.Any) &&
      rowIdx !== undefined &&
      rowIdx !== null &&
      !addedRowIndices.has(rowIdx);

    if (!shouldAddAction) {
      return;
    }

    const batchAllocationAction: IExtendedMetaAction = {
      actionType: ActionType.SalesOrderBatchAllocation,
      options: {
        rowIdx: rowIdx,
      },
    };

    setAddedRowIndices((prev) => new Set(prev).add(rowIdx));
    addModalActions([batchAllocationAction]);
  }, [addModalActions, rowIdx, values.orderLines, addedRowIndices]);

  // salesLineNewPurchaseOrderMap needs clearing down once the purchase orders have been processed/saved
  useEffect(() => {
    if (connectedForm.supportingData?.salesLineNewPurchaseOrderMap) {
      const supportingData = cloneDeep(connectedForm.supportingData);
      const salesLineNewPurchaseOrderMap = supportingData?.salesLineNewPurchaseOrderMap;
      let mapHasChanged = false;
      values.orderLines?.forEach((orderLine) => {
        orderLine?.assignments?.forEach((assignment) => {
          if (
            orderLine?.uuid &&
            salesLineNewPurchaseOrderMap[orderLine.uuid]?.uuid === assignment?.purchaseOrderLine?.purchaseOrder?.uuid
          ) {
            delete salesLineNewPurchaseOrderMap[orderLine.uuid];
            mapHasChanged = true;
          }
        });
      });
      supportingData.salesLineNewPurchaseOrderMap = salesLineNewPurchaseOrderMap;
      if (mapHasChanged) {
        connectedForm.setSupportingData?.(supportingData);
      }
    }
  }, [values.orderLines, connectedForm.supportingData?.salesLineNewPurchaseOrderMap]);

  const renderLineActionButtons = useSalesOrderLineContextActions({ setAddCommentToRow });

  const getTabOptions = (commit: ICommit<ISalesOrderLine>) => {
    if (commit.cellKey === 'product' && getIn(commit, 'updated.product.template')) {
      return {
        xOffset: 1,
      };
    }
    return null;
  };

  useEffect(() => {
    if (!props.formData?.loading) {
      const defaultValues = props.history?.location?.state?.defaultValues as Array<{ field: string; value: any }>;
      if (defaultValues) {
        defaultValues.forEach((defaultValue: any) => {
          dispatch(connectedForm.change(defaultValue.field, defaultValue.value));
        });
      }
    }
    // only want this to trigger when loading ends, not concerned about dispatch/connectedForm changes.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.formData?.loading]);

  const customer = values?.customer;
  let archived = true;
  let originalOrderSummary: Maybe<ISalesOrderSummary> = null;

  if (props.values) {
    archived = !!values.archived;
    originalOrderSummary = values.originalOrderSummary;
  }

  const contactPredefinedFilter: Array<IFilterInput> = [
    {
      filterOperation: FilterOperation.Equals,
      filterParameters: {
        field: 'customer.id',
        value: customer ? customer.id : 0,
      },
    },
    {
      filterOperation: FilterOperation.NotEquals,
      filterParameters: {
        field: 'deliveryType',
        value: 'NOT_ALLOWED',
      },
    },
  ];

  const orderNumber = props.values?.orderNumber || '';
  const orderType = props.values?.orderType;

  let headOffice: Maybe<ICustomer> = null;
  let headOfficeInfo: Maybe<ReactElement> = null;
  if (props.values && props.values.customer) {
    if (props.values.customer.headOffice) {
      headOffice = props.values.customer.headOffice;
    } else {
      headOffice = props.values.customer;
    }
  }

  if (!!headOffice) {
    headOfficeInfo = (
      <InputBlock>
        <InputLabel label={'Head Office'} />
        <InputGroup>
          <a href={`/Customers/Customer/Details/${headOffice.id}`} target="_null">
            {headOffice.reference} - {headOffice.name}
          </a>
        </InputGroup>
      </InputBlock>
    );
  }

  let originalOrderInfo: Maybe<ReactElement> = null;
  if (!!originalOrderSummary) {
    originalOrderInfo = (
      <>
        <Form.Legend label="Original Order" />
        <InputBlock>
          <InputLabel />
          <InputGroup>
            <a href={`/Sales/Order/Details/${originalOrderSummary.id}`} target="_null">
              {originalOrderSummary.orderType} - {originalOrderSummary.orderNumber}
            </a>
          </InputGroup>
        </InputBlock>
      </>
    );
  }

  const cashStatus = values?.cashStatus;

  const includePayment = values?.paymentTotal > 0;
  const payments = values?.payments || [];

  const paymentLines: Array<IPaymentLine & { paymentPrinted: boolean }> = [];
  payments.forEach((payment) => {
    (payment?.paymentLines as Array<IPaymentLine>)?.forEach((paymentLine: IPaymentLine) => {
      paymentLines.push({ ...paymentLine, paymentPrinted: !!payment?.paymentPrinted });
    });
    (payment?.refundLines as Array<IRefundLine>)?.forEach((refundLine: IRefundLine) => {
      paymentLines.push({
        ...(refundLine as IPaymentLine),
        receiptDate: refundLine.refundDate,
        paymentValue: -refundLine.paymentValue,
        paymentPrinted: !!payment?.paymentPrinted,
      });
    });
  });

  const attachmentsCount = getCount(props, 'attachments');
  const linesCount = getCount(props, 'orderLines');

  const mayCreateOrders = checkPermission(props, 'SALES_ORDERS_CREATE');
  const mayCreateQuotes = checkPermission(props, 'SALES_QUOTES_CREATE');
  const permitTypeChange = props.match.params.id === 'New' && mayCreateOrders && mayCreateQuotes;

  const templateButton = null;

  const supplierCountry = props.values?.supplier?.address?.country;
  const deliveryCountry = props.values?.deliveryAddress?.country;

  const priceSelectionPermission = usePriceSelectionPermission();

  const salesEntryGridWithRowUpdated = useSalesEntryGridWithRowUpdated();
  const batchAllocationWithRowUpdated = useBatchAllocationWithRowUpdated();
  const shortageWithRowUpdated = useShortageWithRowUpdated();
  const quoteWithRowUpdated = useQuoteLineWithRowUpdated();
  const validateDispatchGroupCode = useValidateDispatchGroupCode();
  const salesOrderWithRowUpdated = useCallback<IRowUpdatedFunction<ISalesOrderLine>>(
    (commit, dataid, meta) => {
      meta?.connectedForm?.values?.orderLines?.forEach((orderLine: ISalesOrderLine) => {
        if (orderLine?.product?.id === commit?.updated?.product?.id && commit?.original?.uuid !== orderLine?.uuid) {
          const alertText = `${orderLine?.product?.description} has already been added.`;
          dispatch(serviceActions.genericAlert('Product already added', alertText, AlertType.Info));
        }
      });

      salesEntryGridWithRowUpdated(commit, dataid, meta);
      if (orderType !== OrderType.Quote) {
        batchAllocationWithRowUpdated(commit);
      }
      //Resets the "shortageProcessedState" to required on the line, to trigger shortages when appropriate.
      shortageWithRowUpdated(commit);
      validateDispatchGroupCode(commit);
      quoteWithRowUpdated(commit);
    },
    [
      batchAllocationWithRowUpdated,
      dispatch,
      orderType,
      salesEntryGridWithRowUpdated,
      shortageWithRowUpdated,
      validateDispatchGroupCode,
      quoteWithRowUpdated,
    ]
  );

  const customerMemoEditorProps = useMemoEditorProps<ICustomerNotesQueryResult, ICustomerNotesQueryVariables>(
    CustomerNotesWorkspaceQuery,
    IMemoEditorType.Customer,
    {
      predefinedFilters: [
        {
          filterOperation: FilterOperation.Equals,
          filterParameters: {
            field: 'customer.id',
            value: values.customer?.id,
          },
        },
      ],
      skip: !values.customer?.id,
    }
  );
  const salesMemoEditorProps = useMemoEditorProps<ISalesNotesQueryResult, ISalesNotesQueryVariables>(
    SalesNotesWorkspaceQuery,
    IMemoEditorType.SalesOrder,
    {
      predefinedFilters: [
        {
          filterOperation: FilterOperation.Equals,
          filterParameters: {
            field: 'salesOrder.id',
            value: values.id,
          },
        },
      ],
    }
  );

  const isUseAcknowledgedDeliveryDate = orderConfig?.useAcknowledgedDeliveryDate || false;

  const isNotNew = props.match.params.id !== 'New';

  const company = useCompany();
  const windsorFrameworkEnabled = company?.windsorFrameworkEnabled;
  const deliveryAddress = props.values.deliveryAddress;
  const customerPostcode = deliveryAddress?.postCode?.toUpperCase() || '';
  const codeAlpha3 = deliveryAddress?.country?.isoCountry?.codeAlpha3 || '';
  const haulierValue = props.values.haulier || null;

  const isForeignDelivery = useMemo(() => {
    return supplierCountry?.id !== deliveryCountry?.id;
  }, [supplierCountry, deliveryCountry]);

  const showWindsorFrameworkFields = useMemo(() => {
    return windsorFrameworkEnabled && codeAlpha3 === 'GBR' && customerPostcode.startsWith('BT');
  }, [windsorFrameworkEnabled, codeAlpha3, customerPostcode]);

  const showCustomsTab = useMemo(() => {
    return isForeignDelivery || showWindsorFrameworkFields;
  }, [isForeignDelivery, showWindsorFrameworkFields]);

  const { modeOfTransportHint, natureOfTransactionHint, customsProcedureCodeHint } = useInstrastatHints();

  const haulierDetailsPresent = useMemo(() => {
    return haulierValue != null;
  }, [haulierValue]);

  const salesOrderLineColumns = useSalesOrderLineColumns({
    currencyCode: currencyCode,
    setProductModalState: props.setProductModalState,
    match: props.match,
  });

  const viewController = useEditableDataGridViewController({
    viewScreenName: 'sales-order-items-grid',
    columns: salesOrderLineColumns,
    actionProps: {
      individualButton: false,
      text: 'Manage Views (Items Grid)',
    },
  });

  return (
    <Form.FormContainer>
      {viewController.modals}
      <Form.Field<ComponentProps<typeof RecalculatePricingModal>>
        dataid={`recalculatePricing`}
        component={RecalculatePricingModal}
        temporary={true}
        temporaryOnChange={true}
        quoteToOrder={!!getIn(props, 'location.state.defaultValues')}
        onClose={() => {
          setShowRecalculateModal(false);
        }}
        isOpen={showRecalculateModal}
      />
      <BasicConfirmation
        isOpen={unprocessedLines.length > 0}
        title={`Update unprocessed order lines to use ${values?.warehouse?.description}`}
        message={`There are ${unprocessedLines.length} unprocessed order line(s). Do you want to proceed?`}
        onConfirm={() => {
          unprocessedLines.forEach((index) => {
            dispatch(change(connectedForm.form, `orderLines.${index}.warehouse`, values?.warehouse));
          });

          setUnprocessedLines([]);
        }}
        onCancel={() => setUnprocessedLines([])}
      />
      <Form.Header
        entityHdr="orderReference"
        orderNumber={orderNumber}
        component={SalesOrderHeader}
        field="status"
        statusFlags={SALES_ORDER_STATUS_FLAGS}
        values={props.values}
        noDeleteOption={archived}
        includeBorder={true}
        dispatch={dispatch}
        viewController={viewController}
      />
      <Form.Form>
        <Form.Row>
          <Form.Fieldset cols={4 / 12}>
            <Form.Field<IDateFieldProps>
              dataid="orderDate"
              component={input.DateField}
              label="Order Date"
              labelCols={4 / 12}
              inputCols={8 / 12}
            />
            <Form.Field<IDateFieldProps>
              dataid="targetDate"
              component={input.DateField}
              label="Expected Delivery Date"
              labelCols={4 / 12}
              inputCols={8 / 12}
              excludeDays={getExcludedDeliveryDays()}
              hint={'Days are excluded according to the delivery method and delivery instructions'}
            />
            {isUseAcknowledgedDeliveryDate ? (
              <Form.Field<IDateFieldProps>
                dataid="acknowledgedDeliveryDate"
                component={input.DateField}
                label="Acknowledged Delivery Date"
                labelCols={4 / 12}
                inputCols={8 / 12}
                temporary={true}
                temporaryOnChange={true}
              />
            ) : null}
            <Form.Field<IDropdownProps>
              dataid="orderType"
              component={input.Dropdown}
              label="Type"
              temporary={true}
              enum={true}
              options={ORDER_TYPE_OPTIONS}
              readOnly={!permitTypeChange}
              labelCols={4 / 12}
              inputCols={8 / 12}
            />
            {orderType === 'QUOTE' ? (
              <>
                <Form.Field<IDateFieldProps>
                  dataid="expiryDate"
                  component={input.DateField}
                  label="Expiry Date"
                  labelCols={4 / 12}
                  inputCols={8 / 12}
                />
              </>
            ) : null}
            {orderType === 'ORDER' ? (
              <input.Switch
                label="Hide invoiced items"
                onChange={(value) => {
                  setCookie(HIDE_INVOICED_LINE_ITEMS_COOKIE, value, {
                    expires: add(new Date(), { years: 20 }),
                  });
                }}
                labelCols={4 / 12}
                inputCols={8 / 12}
                value={cookies[HIDE_INVOICED_LINE_ITEMS_COOKIE] === 'true'}
                hint={'Hide fully invoiced lines from the Items table. This will not affect the total values.'}
              />
            ) : null}
          </Form.Fieldset>
          <Form.Fieldset cols={5 / 12}>
            {!salesOrderArchivedAndAmazon ? (
              <>
                <Form.Field<IDropdownProps>
                  dataid="customer"
                  component={input.Dropdown}
                  label="Customer"
                  autoFocus={true}
                  temporary={true}
                  busyOnTemporary={true}
                />
                <AddressInfo address={props.values.customer?.address} />
              </>
            ) : (
              <BlurTextField
                value="Redacted on behalf of Amazon"
                label="Customer"
                readOnly={true}
                data-testid="amazon-redacted-customer"
              />
            )}

            <Form.Field<IBlurTextFieldProps>
              dataid="orderReference"
              component={input.BlurTextField}
              label="Order Reference"
              temporary={true}
            />
            {orderType === 'QUOTE' ? (
              <Form.Field<IDropdownProps> dataid="quoteStatus" component={input.Dropdown} enum={true} label="Status" />
            ) : null}
          </Form.Fieldset>

          <Form.Fieldset cols={3 / 12}>
            <OrderTotals
              currencyCode={currencyCode || getIn(props, 'company.baseCurrency.isoCode.codeAlpha3')}
              includePayment={includePayment}
              archived={archived}
              carriageCalculationMethod={props.values.carriageCalculationMethod}
              includeInvoicedCarriageInTotals={orderConfig?.includeInvoicedCarriageInTotals || false}
            />
          </Form.Fieldset>
        </Form.Row>
        <Form.TabPanel
          active={props.values.activeTabId}
          validationFalsePositives={['customer.notes.0.text']}
          switchTabs={true}
        >
          <Form.TabContent id="main" label="Items" badge={linesCount}>
            <GridContainer>
              <CommentRowContext.Provider
                value={{
                  selectRow: (rowIdx: number) => setAddCommentToRow(rowIdx),
                  addCommentToRowIdx: addCommentToRow,
                  dataIdPrefix: `orderLines`,
                }}
              >
                <SalesOrderItemGrid
                  addBlankRow={true}
                  dataid="orderLines"
                  enableCellSelect={!archived}
                  columns={viewController.columns}
                  handleColumnResize={viewController.handleColumnResize}
                  component={AbstractLineGrid}
                  dataStoreId={dataStoreId}
                  contentHeight={itemTableHeight}
                  onCellSelected={onCellSelected}
                  onChange={onRowUpdated}
                  onRowClick={onRowClick}
                  withRowUpdated={salesOrderWithRowUpdated}
                  normalize={normalizeOrderLines}
                  temporaryOnFocus={false}
                  ignoreMutationIdCheck={false}
                  rowRenderer={SalesOrderRowRenderer}
                  contextKey={'orderLines'}
                  enableContextMenu={true}
                  renderActionButtons={renderLineActionButtons}
                  getTabOptions={getTabOptions}
                  ignoreKeypresses={props.itemGridIgnoreKeypresses} //Make grid un-tabbable while a Modal is open.
                  debounceMS={1000}
                  disableVirtualRows={true}
                  hideArchivedLines={true}
                  selectCellFormatter={SalesOrderStatusCellFormatter}
                />
              </CommentRowContext.Provider>
            </GridContainer>
            {templateButton}
            <LineDetailsPanel
              key={`ldp_${rowIdx}`}
              orderLines={props.values.orderLines}
              rowIndex={rowIdx}
              colIdx={colIdx}
              active={active}
              field={'orderLines'}
              currencyCode={currencyCode}
              orderType={orderType}
              itemInformationQuery={SalesOrderLineItemInformationQuery}
              isUseAcknowledgedDeliveryDate={orderConfig?.useAcknowledgedDeliveryDate}
            />
          </Form.TabContent>
          <Form.TabContent id="header" label="Header">
            <Form.Row>
              <Form.Fieldset cols={2 / 3}>
                <Form.Legend label="General" />
                <Form.Field<IDropdownProps>
                  dataid="vatBusinessCategory"
                  component={input.Dropdown}
                  label="VAT Status"
                />
                <Form.Field
                  dataid="vatInclusive"
                  component={input.Checkbox}
                  label="VAT Inclusive Prices"
                  temporary={true}
                />
                <Form.Field<IDropdownProps>
                  dataid="paymentTerm"
                  component={input.Dropdown}
                  label="Payment Terms"
                  rawLabel={true}
                />
                <Form.Field<IDropdownProps>
                  dataid="currency"
                  component={input.Dropdown}
                  label="Currency"
                  readOnly={true}
                />
                <Form.Field<IDropdownProps> dataid="certificate" component={input.Dropdown} label="Certificate" />
                <Form.Field<IDropdownProps>
                  dataid="warehouse"
                  component={input.Dropdown}
                  label="Warehouse"
                  onChange={(event, newValue, oldValue) => {
                    if (newValue?.id !== oldValue?.id) {
                      const orderLines = connectedForm?.values?.orderLines || [];
                      const unprocessedOrderLines = orderLines
                        .map((orderLine: { salesOrderLineStatus: string[] }, index: number) =>
                          !orderLine.salesOrderLineStatus ||
                          orderLine.salesOrderLineStatus.every((status) =>
                            [
                              SalesOrderLineStatus.Quoted,
                              SalesOrderLineStatus.Enquiring,
                              SalesOrderLineStatus.AwaitingAllocation,
                              SalesOrderLineStatus.AwaitingProduction,
                            ].includes(status as SalesOrderLineStatus)
                          )
                            ? index
                            : -1
                        )
                        .filter((index: number) => index !== -1);

                      if (unprocessedOrderLines?.length > 0) {
                        setUnprocessedLines(unprocessedOrderLines);
                      }
                    }
                  }}
                  temporary={true}
                  hint={'Specifies the default warehouse assigned to newly added sales order lines'}
                />
                <Form.Field<IDropdownProps> dataid="paymentMethod" component={input.Dropdown} label="Payment Method" />
                {orderType !== 'QUOTE' && getIn(props, 'documentConfig.data.acknowledgementDefault.documentsInUse') ? (
                  <Form.Field
                    dataid="acknowledgementRequired"
                    component={input.Checkbox}
                    label="Acknowledgement Required"
                  />
                ) : null}
                {orderType === 'QUOTE' &&
                getIn(props, 'documentConfig.data.quotationDocumentDefault.documentsInUse') ? (
                  <Form.Field
                    dataid="quotationDocumentRequired"
                    component={input.Checkbox}
                    label="Quotation Document Required"
                  />
                ) : (
                  <Form.Field dataid="held" component={input.Checkbox} label="Held" />
                )}
                <Form.Field<IBlurTextFieldProps>
                  dataid="comment"
                  component={input.BlurTextField}
                  type={BlurTextFieldType.TextArea}
                  label="Comment"
                />
                {orderType !== 'QUOTE' ? (
                  <>
                    <Form.Legend label="Activation" />
                    <Form.Field dataid="activated" component={input.Checkbox} label="Activated" readOnly={true} />
                    <Form.Field<IDateFieldProps>
                      dataid="activationDate"
                      component={input.DateField}
                      label="Activation Date"
                      temporary={true}
                      temporaryOnChange={true}
                    />
                    <Form.Field<IDropdownProps>
                      dataid="salesOrderActivationType"
                      component={input.Dropdown}
                      label="Activation Type"
                      temporary={true}
                      temporaryOnChange={true}
                      clearable={true}
                      readOnly={archived}
                    />
                    <Form.Legend label="Cash" />
                    <Form.Field<IDropdownProps>
                      dataid="cashStatus"
                      component={input.Dropdown}
                      label="Cash with Order/Proforma"
                      temporary={true}
                    />
                    {cashStatus !== 'NONE' ? (
                      <Form.Field dataid="cashReceived" component={input.Checkbox} label="Cash Received" />
                    ) : null}
                    {cashStatus === 'PRO_FORMA' ? (
                      <>
                        <Form.Field
                          dataid="proformaDocumentRequired"
                          component={input.Checkbox}
                          label="Proforma Required"
                        />
                        {(payByLinks?.data?.length ?? 0) > 0 ? (
                          <>
                            <Form.Legend label="Pay By Link" />
                            {payByLinks?.data?.map((payByLink: string) => {
                              return (
                                <BlurTextField
                                  key={payByLink}
                                  data-testid="payByLink"
                                  value={payByLink}
                                  includeLabel={false}
                                  copy
                                />
                              );
                            })}
                          </>
                        ) : null}
                      </>
                    ) : null}
                  </>
                ) : null}
                <Form.Legend label="Pricing" />
                <Form.Field<IDropdownProps>
                  dataid="defaultPriceBand"
                  component={input.Dropdown}
                  options={getPriceBands(props?.productConfig?.data)}
                  dynamicOptions={true}
                  labelKey="title"
                  valueKey="price"
                  label="Price Band"
                  normalize={(dataid, value) => {
                    return value.price;
                  }}
                  readOnly={priceSelectionPermission === PriceSelectionPermission.None}
                />
                <Form.Field<IBlurTextFieldProps>
                  dataid="overallDiscountPercent"
                  label="Overall Discount %"
                  component={input.DiscountInput}
                  prefix="-"
                  suffix="%"
                  temporary={true}
                  readOnly={
                    priceSelectionPermission !== PriceSelectionPermission.Manual &&
                    priceSelectionPermission !== PriceSelectionPermission.RestrictedWithManual
                  }
                />
                <Form.Field<IBlurTextFieldProps>
                  dataid="orderDiscount"
                  label="Fixed Discount Value"
                  component={input.DiscountInput}
                  prefix="-"
                  temporary={true}
                  type={BlurTextFieldType.Currency}
                  readOnly={
                    priceSelectionPermission !== PriceSelectionPermission.Manual &&
                    priceSelectionPermission !== PriceSelectionPermission.RestrictedWithManual
                  }
                />
                {!salesOrderArchivedAndAmazon ? (
                  <>
                    <Form.Legend label="Invoice Account" />
                    {headOfficeInfo}
                    <Form.Field<IBlurTextFieldProps>
                      dataid="invoiceCompany"
                      component={input.BlurTextField}
                      label="Invoice Company"
                      enableOnChange={true}
                      onChange={(event, newValue) => {
                        if (values?.useInvoiceAddressForDelivery) {
                          connectedForm.change(`deliveryName`, newValue);
                        }
                      }}
                    />
                  </>
                ) : null}

                <ConnectedAddress
                  dataid={'invoiceAddress'}
                  labelOverrides={{ line1: 'Address', line2: '', line3: '', line4: '', line5: '' }}
                  loqateProps={{ companyDataid: 'invoiceCompany' }}
                  onChangeField={(fieldName: string, value: string) => {
                    if (values?.useInvoiceAddressForDelivery) {
                      connectedForm.change(`deliveryAddress.${fieldName}`, value);
                    }
                  }}
                />
                <Form.Field
                  dataid="useInvoiceAddressForDelivery"
                  component={input.Checkbox}
                  label="Use Invoice Address For Delivery"
                  readOnly={false}
                  onChange={(event, newValue) => {
                    updateDeliveryAddress(!newValue);
                  }}
                  hint="Invoice address lines will be used for the delivery address. Note: the 'Contact' and 'Delivery name' will be locked. "
                />
                {originalOrderInfo}
              </Form.Fieldset>
              <Form.Fieldset cols={1 / 3}>
                <ValueBreakdown />
                {orderType !== 'QUOTE' && (
                  <>
                    <Form.Legend label="Invoiced Carriage" />
                    <Form.Row>
                      <Form.Fieldset cols={1 / 3} collapsed={true}>
                        <Label>Carriage</Label>
                      </Form.Fieldset>
                      <Form.Fieldset cols={1 / 3} collapsed={true}>
                        <Form.Field<IBlurTextFieldProps>
                          dataid="carriageInvoiced"
                          datatype="numeric"
                          component={input.BlurTextField}
                          readOnly={true}
                          includeLabel={false}
                          type={BlurTextFieldType.Currency}
                        />
                      </Form.Fieldset>
                      <Form.Fieldset cols={1 / 3} collapsed={true}>
                        <Form.Field<IBlurTextFieldProps>
                          dataid="carriageInvoicedVat"
                          datatype="numeric"
                          component={input.BlurTextField}
                          includeLabel={false}
                          readOnly={true}
                          type={BlurTextFieldType.Currency}
                        />
                      </Form.Fieldset>
                    </Form.Row>
                  </>
                )}

                {fullUserDetails?.companyUser?.costViewPermission &&
                fullUserDetails.companyUser.costViewPermission !== CostViewPermission.None ? (
                  <>
                    <Form.Legend label="Cost / Profit" />
                    <Form.Row>
                      <Form.Fieldset cols={1 / 3} collapsed={true}>
                        <Label>Total Cost</Label>
                      </Form.Fieldset>
                      <Form.Fieldset cols={1 / 3} collapsed={true}>
                        <Form.Field<IBlurTextFieldProps>
                          dataid="displayCostTotal"
                          datatype="numeric"
                          component={input.BlurTextField}
                          readOnly={true}
                          includeLabel={false}
                          type={BlurTextFieldType.Currency}
                        />
                      </Form.Fieldset>
                    </Form.Row>
                    <Form.Row>
                      <Form.Fieldset cols={1 / 3} collapsed={true}>
                        <Label>Profit</Label>
                      </Form.Fieldset>
                      <Form.Fieldset cols={1 / 3} collapsed={true}>
                        <Form.Field<IBlurTextFieldProps>
                          dataid="displayProfitValue"
                          datatype="numeric"
                          component={input.BlurTextField}
                          readOnly={true}
                          decimals={2}
                          includeLabel={false}
                          type={BlurTextFieldType.Currency}
                        />
                      </Form.Fieldset>
                    </Form.Row>
                    <Form.Row>
                      <Form.Fieldset cols={1 / 3} collapsed={true}>
                        <Label>Profit %</Label>
                      </Form.Fieldset>
                      <Form.Fieldset cols={1 / 3} collapsed={true}>
                        <Form.Field<IBlurTextFieldProps>
                          dataid="displayProfitMargin"
                          datatype="numeric"
                          component={input.BlurTextField}
                          readOnly={true}
                          decimals={2}
                          includeLabel={false}
                        />
                      </Form.Fieldset>
                    </Form.Row>
                  </>
                ) : null}
              </Form.Fieldset>
            </Form.Row>
          </Form.TabContent>
          <Form.TabContent id="attributes" label="Attributes">
            <Form.Row>
              <Form.Fieldset cols={2 / 3}>
                <Form.Legend label="Attributes" />
                <Form.Field<IAttributeArrayProps>
                  dataid="attributeValues"
                  component={input.AttributeArray}
                  label="Attributes"
                  query={entities.SalesAttributeConfig.list}
                  initialized={true}
                  type={'sales'}
                />
              </Form.Fieldset>
              <Form.Fieldset cols={5 / 8}>
                <Form.Legend label="Customer Attributes" />
                <Form.Field<IAttributeArrayProps>
                  dataid="customer.attributeValues"
                  component={input.AttributeArray}
                  label="Customer Attributes"
                  query={CustomerAttributeConfig.list}
                  type={'customer'}
                  readOnly={true}
                />
              </Form.Fieldset>
            </Form.Row>
          </Form.TabContent>
          <Form.TabContent id="currency" label="Currency" shouldRender={foreignCurrency} onlyRenderWhenActive={true}>
            <Form.Row>
              <Form.Fieldset cols={1 / 3}>
                <Form.Row>
                  <Form.Fieldset cols={1} collapsed={true}>
                    <Form.Field<IBlurTextFieldProps>
                      dataid="exchangeRate"
                      datatype="numeric"
                      component={input.BlurTextField}
                      label={'Exchange Rate'}
                      readOnly={true}
                      decimals={2}
                    />
                  </Form.Fieldset>
                </Form.Row>

                <Form.Legend label="Value Breakdown" />
                <Form.Row>
                  <Form.Fieldset cols={1 / 3} collapsed={true} />
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <ColumnLabel label={currencyCode} textAlign={'right'} />
                  </Form.Fieldset>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <ColumnLabel label={getIn(props, 'company.baseCurrency.isoCode.codeAlpha3')} textAlign={'right'} />
                  </Form.Fieldset>
                </Form.Row>

                <Form.Row>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Label>Gross Goods</Label>
                  </Form.Fieldset>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Form.Field<IBlurTextFieldProps>
                      dataid="grossGoodsTotal"
                      datatype="numeric"
                      component={input.BlurTextField}
                      readOnly={true}
                      includeLabel={false}
                      type={BlurTextFieldType.Currency}
                    />
                  </Form.Fieldset>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Form.Field<IBlurTextFieldProps>
                      dataid="baseGrossGoodsTotal"
                      datatype="numeric"
                      component={input.BlurTextField}
                      readOnly={true}
                      includeLabel={false}
                      type={BlurTextFieldType.BaseCurrency}
                    />
                  </Form.Fieldset>
                </Form.Row>

                <Form.Row>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Label>Discount</Label>
                  </Form.Fieldset>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Form.Field<IBlurTextFieldProps>
                      dataid="overallDiscountValue"
                      datatype="numeric"
                      component={input.BlurTextField}
                      readOnly={true}
                      includeLabel={false}
                      type={BlurTextFieldType.Currency}
                    />
                  </Form.Fieldset>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Form.Field<IBlurTextFieldProps>
                      dataid="baseOverallDiscountValue"
                      datatype="numeric"
                      component={input.BlurTextField}
                      readOnly={true}
                      includeLabel={false}
                      type={BlurTextFieldType.BaseCurrency}
                    />
                  </Form.Fieldset>
                </Form.Row>

                <Form.Row>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Label>Net Goods</Label>
                  </Form.Fieldset>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Form.Field<IBlurTextFieldProps>
                      dataid="nettGoodsTotal"
                      datatype="numeric"
                      component={input.BlurTextField}
                      readOnly={true}
                      includeLabel={false}
                      type={BlurTextFieldType.Currency}
                    />
                  </Form.Fieldset>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Form.Field<IBlurTextFieldProps>
                      dataid="baseNettGoodsTotal"
                      datatype="numeric"
                      component={input.BlurTextField}
                      readOnly={true}
                      includeLabel={false}
                      type={BlurTextFieldType.BaseCurrency}
                    />
                  </Form.Fieldset>
                </Form.Row>

                <Form.Row>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Label>Cost</Label>
                  </Form.Fieldset>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Form.Field<IBlurTextFieldProps>
                      dataid="costTotal"
                      datatype="numeric"
                      component={input.BlurTextField}
                      readOnly={true}
                      includeLabel={false}
                      type={BlurTextFieldType.Currency}
                    />
                  </Form.Fieldset>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Form.Field<IBlurTextFieldProps>
                      dataid="baseCostTotal"
                      datatype="numeric"
                      component={input.BlurTextField}
                      readOnly={true}
                      includeLabel={false}
                      type={BlurTextFieldType.BaseCurrency}
                    />
                  </Form.Fieldset>
                </Form.Row>

                <Form.Row>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Label>Profit</Label>
                  </Form.Fieldset>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Form.Field<IBlurTextFieldProps>
                      dataid="profitValue"
                      datatype="numeric"
                      component={input.BlurTextField}
                      readOnly={true}
                      includeLabel={false}
                      type={BlurTextFieldType.Currency}
                    />
                  </Form.Fieldset>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Form.Field<IBlurTextFieldProps>
                      dataid="baseProfitValue"
                      datatype="numeric"
                      component={input.BlurTextField}
                      readOnly={true}
                      includeLabel={false}
                      type={BlurTextFieldType.BaseCurrency}
                    />
                  </Form.Fieldset>
                </Form.Row>
                <Form.Legend label="" />
                <Form.Row>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Label>Order Total</Label>
                  </Form.Fieldset>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Form.Field<IBlurTextFieldProps>
                      dataid="headerTotal"
                      datatype="numeric"
                      component={input.BlurTextField}
                      readOnly={true}
                      includeLabel={false}
                      type={BlurTextFieldType.Currency}
                    />
                  </Form.Fieldset>
                  <Form.Fieldset cols={1 / 3} collapsed={true}>
                    <Form.Field<IBlurTextFieldProps>
                      dataid="baseHeaderTotal"
                      datatype="numeric"
                      component={input.BlurTextField}
                      readOnly={true}
                      includeLabel={false}
                      type={BlurTextFieldType.BaseCurrency}
                    />
                  </Form.Fieldset>
                </Form.Row>
              </Form.Fieldset>
            </Form.Row>
          </Form.TabContent>
          <Form.TabContent id="delivery" label="Delivery" onlyRenderWhenActive={true}>
            <Form.Row>
              <Form.Fieldset cols={1 / 2}>
                <Form.Legend label="Delivery" />
                {!salesOrderArchivedAndAmazon ? (
                  <Fragment>
                    <Form.Field<IDropdownProps>
                      dataid="customerContact"
                      component={input.Dropdown}
                      label="Contact"
                      predefinedFilters={contactPredefinedFilter}
                      temporaryOnChange={true}
                      readOnly={values.useInvoiceAddressForDelivery ?? false}
                      onChange={(value) => {
                        dispatch(props.change('deliveryAddress', value.address));
                      }}
                      remoteFilter={true}
                      filterOptions={(options: Array<any>) => options}
                      customIcon={CustomerGlobalContactLookupIcon}
                      entity={CustomerContact}
                    />
                    <Form.Field<ComponentProps<typeof DeliveryLookupField>>
                      dataid="deliveryName"
                      addressDataId="deliveryAddress"
                      label="Delivery Name"
                      component={DeliveryLookupField}
                      readOnly={values.useInvoiceAddressForDelivery ?? false}
                      predefinedFilters={
                        values.customer?.id
                          ? [
                              {
                                filterOperation: FilterOperation.Equals,
                                filterParameters: {
                                  field: 'customerId',
                                  value: values.customer.id,
                                },
                              },
                            ]
                          : []
                      }
                    />
                    <ConnectedAddress
                      dataid={'deliveryAddress'}
                      postCodeProps={{ temporary: windsorFrameworkEnabled ?? false }}
                      labelDefaults={{ line1: 'Delivery Address' }}
                      readOnly={values.useInvoiceAddressForDelivery ?? false}
                    />
                    <Form.Field<IBlurTextFieldProps>
                      dataid="deliveryPhoneNumber"
                      label="Phone Number"
                      component={input.BlurTextField}
                      hyperlink={HrefLink.Tel}
                    />
                    <Form.Field<IBlurTextFieldProps>
                      dataid="deliveryMobileNumber"
                      label="Mobile Number"
                      component={input.BlurTextField}
                      hyperlink={HrefLink.Tel}
                    />
                    <Form.Field<IBlurTextFieldProps>
                      dataid="deliveryEmail"
                      label="Email"
                      component={input.BlurTextField}
                      hyperlink={HrefLink.MailTo}
                    />
                  </Fragment>
                ) : (
                  <div>Redacted on behalf of Amazon</div>
                )}
                <Form.Field
                  dataid="dispatchCompleteOnly"
                  component={input.Checkbox}
                  label="Dispatch complete order only?"
                />
              </Form.Fieldset>
              <Form.Fieldset cols={1 / 2}>
                <Form.Legend
                  label="Carriage"
                  description={'Outstanding weights are calculated from the quantity that has yet to be dispatched'}
                />
                <Form.Row>
                  <Form.Fieldset cols={1}>
                    <Form.Field<IBlurTextFieldProps>
                      dataid="weightTotal"
                      label="Net Product Weight"
                      component={input.BlurTextField}
                      readOnly={true}
                      labelCols={2 / 5}
                      inputCols={3 / 5}
                    />
                    <Form.Field<IBlurTextFieldProps>
                      dataid="packagingWeightTotal"
                      label="Packaging Weight"
                      component={input.BlurTextField}
                      readOnly={true}
                      labelCols={2 / 5}
                      inputCols={3 / 5}
                    />
                    <Form.Field<IBlurTextFieldProps>
                      dataid="grossWeightTotal"
                      label="Gross Order Weight"
                      component={input.BlurTextField}
                      readOnly={true}
                      labelCols={2 / 5}
                      inputCols={3 / 5}
                    />
                    <Form.Field<IBlurTextFieldProps>
                      dataid="outstandingWeightTotal"
                      label="Outstanding Net Product Weight"
                      component={input.BlurTextField}
                      readOnly={true}
                      labelCols={2 / 5}
                      inputCols={3 / 5}
                    />
                    <Form.Field<IBlurTextFieldProps>
                      dataid="outstandingPackagingWeightTotal"
                      label="Outstanding Packaging Weight"
                      component={input.BlurTextField}
                      readOnly={true}
                      labelCols={2 / 5}
                      inputCols={3 / 5}
                    />
                    <Form.Field<IBlurTextFieldProps>
                      dataid="outstandingGrossWeightTotal"
                      label="Outstanding Gross Order Weight"
                      component={input.BlurTextField}
                      readOnly={true}
                      labelCols={2 / 5}
                      inputCols={3 / 5}
                    />
                  </Form.Fieldset>
                </Form.Row>
                <Form.Row>
                  <Form.Fieldset cols={1}>
                    <Form.Field<IFluentTextFieldProps>
                      dataid="packagingVolumeTotal"
                      label="Packaging Volume"
                      component={FluentTextField}
                      suffix="m³"
                      readOnly={true}
                      temporary={true}
                      labelCols={2 / 5}
                      inputCols={3 / 5}
                    />
                    <Form.Field<ICheckboxInputProps>
                      dataid="manualDeliveryMethod"
                      label="Manual Delivery Method"
                      component={input.Checkbox}
                      readOnly={archived}
                      temporaryOnChange={true}
                      labelCols={2 / 5}
                      inputCols={3 / 5}
                    />
                    <Form.Field<IDropdownProps>
                      dataid="deliveryMethod"
                      label="Delivery Method"
                      component={input.Dropdown}
                      readOnly={archived || !values?.manualDeliveryMethod}
                      temporaryOnChange={true}
                      labelCols={2 / 5}
                      inputCols={3 / 5}
                    />
                    <Form.Field<IDropdownProps>
                      dataid="carriageCalculationMethod"
                      label="Carriage Calculation Method"
                      component={input.Dropdown}
                      readOnly={archived}
                      temporary={true}
                      labelCols={2 / 5}
                      inputCols={3 / 5}
                    />
                    {props.values.carriageCalculationMethod !== CarriageCalculationMethod.NoneRequired ? (
                      <>
                        <Form.Field<IBlurTextFieldProps>
                          dataid="carriageTotal"
                          label="Carriage Total"
                          component={input.BlurTextField}
                          readOnly={
                            archived || props.values.carriageCalculationMethod === CarriageCalculationMethod.Calculated
                          }
                          temporary={true}
                          type={BlurTextFieldType.Currency}
                          decimals={2}
                          labelCols={2 / 5}
                          inputCols={3 / 5}
                        />
                        {fullUserDetails?.companyUser?.carriageCostsViewable && (
                          <Form.Field<IBlurTextFieldProps>
                            dataid="carriageCostPerDelivery"
                            label="Carriage Cost"
                            component={input.BlurTextField}
                            readOnly={
                              archived ||
                              props.values.carriageCalculationMethod === CarriageCalculationMethod.Calculated
                            }
                            temporary={true}
                            type={BlurTextFieldType.Currency}
                            decimals={2}
                            labelCols={2 / 5}
                            inputCols={3 / 5}
                          />
                        )}
                        <Form.Field<IDropdownProps>
                          dataid="carriageVatProductCategory"
                          label="Carriage VAT Category"
                          component={input.Dropdown}
                          readOnly={archived}
                          temporary={true}
                          reformatLabel={false}
                          labelCols={2 / 5}
                          inputCols={3 / 5}
                        />
                        <Form.Field<IBlurTextFieldProps>
                          dataid="carriageInvoiced"
                          label="Carriage Invoiced"
                          component={input.BlurTextField}
                          readOnly={true}
                          type={BlurTextFieldType.Currency}
                          decimals={2}
                          labelCols={2 / 5}
                          inputCols={3 / 5}
                        />
                      </>
                    ) : null}

                    <Form.Field dataid="haulier" component={input.Dropdown} readOnly={archived} label="Haulier" />

                    {haulierDetailsPresent && (
                      <>
                        <Form.Legend label="Contact Details (for Haulier)" />
                        <Form.Field
                          dataid="haulier.contactName"
                          component={input.BlurTextField}
                          label="Contact name"
                          readOnly
                        />
                        <Form.Field dataid="haulier.line1" component={input.BlurTextField} label="Address" readOnly />
                        <Form.Field dataid="haulier.line2" component={input.BlurTextField} readOnly />
                        <Form.Field dataid="haulier.line3" component={input.BlurTextField} readOnly />
                        <Form.Field dataid="haulier.line4" component={input.BlurTextField} readOnly />
                        <Form.Field dataid="haulier.line5" component={input.BlurTextField} readOnly />
                        <Form.Field
                          dataid="haulier.postCode"
                          component={input.BlurTextField}
                          label="Post Code"
                          readOnly
                        />
                        <Form.Field dataid="haulier.country" component={input.Dropdown} label="Country" readOnly />
                        <Form.Field
                          dataid="haulier.telephoneNumber"
                          component={input.BlurTextField}
                          label="Telephone Number"
                          readOnly
                        />
                        <Form.Field
                          dataid="haulier.mobileNumber"
                          component={input.BlurTextField}
                          label="Mobile Number"
                          readOnly
                        />
                        <Form.Field
                          dataid="haulier.contactEmail"
                          component={input.BlurTextField}
                          label="Email"
                          readOnly
                        />
                      </>
                    )}
                    {!haulierDetailsPresent && (
                      <>
                        <Form.Legend label="Contact Details (for Carrier)" />
                        <Form.Field
                          dataid="deliveryMethod.carrier.contactName"
                          component={input.BlurTextField}
                          label="Contact name"
                          readOnly
                        />
                        <Form.Field
                          dataid="deliveryMethod.carrier.line1"
                          component={input.BlurTextField}
                          label="Address"
                          readOnly
                        />
                        <Form.Field dataid="deliveryMethod.carrier.line2" component={input.BlurTextField} readOnly />
                        <Form.Field dataid="deliveryMethod.carrier.line3" component={input.BlurTextField} readOnly />
                        <Form.Field dataid="deliveryMethod.carrier.line4" component={input.BlurTextField} readOnly />
                        <Form.Field dataid="deliveryMethod.carrier.line5" component={input.BlurTextField} readOnly />
                        <Form.Field
                          dataid="deliveryMethod.carrier.postCode"
                          component={input.BlurTextField}
                          label="Post Code"
                          readOnly
                        />
                        <Form.Field
                          dataid="deliveryMethod.carrier.country"
                          component={input.Dropdown}
                          label="Country"
                          readOnly
                        />
                        <Form.Field
                          dataid="deliveryMethod.carrier.telephoneNumber"
                          component={input.BlurTextField}
                          label="Telephone Number"
                          readOnly
                        />
                        <Form.Field
                          dataid="deliveryMethod.carrier.mobileNumber"
                          component={input.BlurTextField}
                          label="Mobile Number"
                          readOnly
                        />
                        <Form.Field
                          dataid="deliveryMethod.carrier.contactEmail"
                          component={input.BlurTextField}
                          label="Email"
                          readOnly
                        />
                      </>
                    )}
                  </Form.Fieldset>
                </Form.Row>
              </Form.Fieldset>
            </Form.Row>
          </Form.TabContent>
          <Form.TabContent id="customs" label="Customs" onlyRenderWhenActive={true} shouldRender={showCustomsTab}>
            <Form.Row>
              <Form.Fieldset cols={1}>
                <Form.Legend label="Intrastat" />
                <Form.Field<IDropdownProps>
                  dataid="intrastatDetails.termsOfDelivery"
                  component={input.Dropdown}
                  clearable={true}
                  label="Terms of Delivery"
                  readOnly={archived}
                />
                <Form.Field<IBlurTextFieldProps>
                  dataid="reasonForExport"
                  component={input.BlurTextField}
                  label="Reason for Export"
                  readOnly={archived}
                />
                <Form.Field<IBlurTextFieldProps>
                  dataid="intrastatDetails.natureOfTransactionCode"
                  label="Nature of Transaction"
                  component={input.BlurTextField}
                  hint={natureOfTransactionHint}
                  type={BlurTextFieldType.FluentMask}
                  mask="99"
                  readOnly={archived}
                />
                <Form.Field<IBlurTextFieldProps>
                  dataid="intrastatDetails.customsProcedureCode"
                  label="Customs Procedure Code"
                  component={input.BlurTextField}
                  temporary={true}
                  hint={customsProcedureCodeHint}
                  type={BlurTextFieldType.FluentMask}
                  mask="99-99-999"
                />
                <Form.Field<IBlurTextFieldProps>
                  dataid="intrastatDetails.modeOfTransportCode"
                  label="Mode Of Transport Code"
                  component={input.BlurTextField}
                  hint={modeOfTransportHint}
                  type={BlurTextFieldType.FluentMask}
                  mask="9"
                />
                {showWindsorFrameworkFields && (
                  <>
                    <Form.Field<IDropdownProps>
                      dataid="windsorFrameworkAtRiskStatus"
                      component={input.Dropdown}
                      label="Windsor Framework At Risk"
                    />
                    <Form.Field<IBlurTextFieldProps>
                      dataid="windsorFrameworkUkims"
                      component={input.BlurTextField}
                      label="UKIMS"
                      reformatLabel={false}
                    />
                  </>
                )}
              </Form.Fieldset>
            </Form.Row>
          </Form.TabContent>
          <Form.TabContent id="events" label="Tasks" shouldRender={isNotNew} onlyRenderWhenActive={true}>
            <Suspense fallback={<ProgressIndicator />}>
              <GridContainer>
                <LazyDiaryEventWorkspace
                  embeddedView={true}
                  predefinedFilters={eventPredefinedFilters}
                  viewScreenName="/Diary/Task/Modal"
                  removeAddButton={false}
                />
              </GridContainer>
            </Suspense>
          </Form.TabContent>
          <Form.TabContent
            id="documents"
            label="Document History"
            tabStyle={{ width: '140px' }}
            shouldRender={isNotNew && !salesOrderArchivedAndAmazon}
            onlyRenderWhenActive={true}
          >
            <DocumentSummaryWorkspace
              preview={true}
              embeddedView={true}
              predefinedFilters={[
                {
                  filterOperation: FilterOperation.Equals,
                  filterParameters: {
                    field: 'transactionId',
                    value: props.values.id,
                  },
                },
                {
                  filterOperation: FilterOperation.Equals,
                  filterParameters: {
                    field: 'transactionEntity',
                    value: 'SALES_ORDER',
                  },
                },
              ]}
              viewScreenName="/Common/DocumentSummary/Modal"
              removeAddButton={true}
            />
          </Form.TabContent>
          <Form.TabContent
            id="invoiceDocuments"
            label="Invoice Documents"
            tabStyle={{ width: '140px' }}
            onlyRenderWhenActive={true}
            shouldRender={isNotNew && !!props.values.id && !salesOrderArchivedAndAmazon}
          >
            <InvoiceDocumentsOrderGrid salesOrderId={props.values.id} />
          </Form.TabContent>
          <Form.TabContent id="attachments" label="Attachments" badge={attachmentsCount} onlyRenderWhenActive={true}>
            <Form.Row>
              <Form.Fieldset cols={1}>
                <Form.Legend label="Attachments" />
                <Form.Field<IGridUploaderProps>
                  dataid="attachments"
                  component={input.GridUploader}
                  forceReadOnly={false}
                  temporaryOnChange={true}
                  additionalColumns={[
                    {
                      name: 'Document Type',
                      key: 'type',
                      editable: false,
                      resizable: true,
                      draggable: false,
                    },
                    {
                      name: 'Printed',
                      key: 'printedWithInvoice',
                      formatter: Formatters.BooleanFormatter,
                      editable: false,
                      resizable: true,
                      draggable: false,
                    },
                    {
                      name: 'Attach on Documents',
                      key: 'includeOnDocuments',
                      widthFactor: 1,
                      formatter: Formatters.CheckFormatter,
                      editor: CheckboxEditor,
                      editable: true,
                      resizable: true,
                      draggable: false,
                    },
                    {
                      name: 'Export to Web',
                      key: 'exportToWeb',
                      widthFactor: 1,
                      formatter: Formatters.CheckFormatter,
                      editor: <AnyCheckboxEditor />,
                      editable: true,
                      resizable: true,
                      draggable: false,
                    },
                  ]}
                />
              </Form.Fieldset>
            </Form.Row>
          </Form.TabContent>
          <Form.TabContent
            id="notesTab"
            label="Notes"
            badge={salesMemoEditorProps.queryProps.data?.listData?.count}
            type="info"
            onlyRenderWhenActive={true}
            shouldRender={isNotNew}
          >
            <MemoEditor noteTypeEntity={SalesNoteType} {...salesMemoEditorProps} />
          </Form.TabContent>
          <Form.TabContent
            id="customerNotesTab"
            label="Customer Notes"
            badge={customerMemoEditorProps.queryProps.data?.listData?.count}
            type="info"
            tabStyle={{ width: '150px' }}
            shouldRender={props.values?.customer}
            onlyRenderWhenActive={true}
          >
            <MemoEditor noteTypeEntity={CustomerNoteType} {...customerMemoEditorProps} path={'customer'} />
          </Form.TabContent>
          <Form.TabContent id="dispatch" label="Dispatch" onlyRenderWhenActive={true}>
            <Form.Row>
              <Form.Fieldset cols={1}>
                <GridContainer>
                  <Form.Field<IEditableDataGridProps>
                    dataid="dispatchInstructions"
                    component={EditableDataGrid}
                    columns={DISPATCH_COLUMN_META}
                    onRowClick={setSelectedDispatchRow as unknown as (rowIdx: number) => void}
                    autoContentHeight
                  />
                </GridContainer>
              </Form.Fieldset>
            </Form.Row>
            {selectedDispatchRow !== null && props.values?.dispatchInstructions?.[selectedDispatchRow] ? (
              <TrackingDetailsForDispatchInstruction
                dispatchInstruction={props.values.dispatchInstructions[selectedDispatchRow]}
              />
            ) : null}
          </Form.TabContent>
          <Form.TabContent
            id="maxoptra"
            label="Maxoptra"
            onlyRenderWhenActive={true}
            shouldRender={isNotNew && fullUserDetails?.flags?.maxoptraEnabled}
          >
            <MaxoptraTab salesOrderId={values.id} />
          </Form.TabContent>
          <Form.TabContent id="lineDetails" label="Line details" onlyRenderWhenActive={true}>
            <LazySalesOrderLineWorkspace
              embeddedView={true}
              allowView={false}
              columnData={DISPATCH_DETAIL_FIELD_NAMES}
              initialSortColumn={props.values?.linesSortColumn || 'lineOrder'}
              initialSortDir={props.values?.linesSortDirection || 'ASC'}
              predefinedFilters={[
                {
                  filterOperation: 'EQUALS',
                  filterParameters: {
                    field: 'salesOrder.id',
                    value: getIdFromPropsForFilter(props),
                  },
                },
              ]}
              noEdit={true}
              viewScreenName={'/Dispatch/Orders/Modal/'}
              contentHeight={itemTableHeight}
              onRowClick={(row: ISalesOrderLine) => {
                setLineDetailsSelected(row || {});
              }}
            />
            <Form.TabPanel>
              <Form.TabContent id="invoices" label="Invoices" key="invoices" onlyRenderWhenActive={true}>
                <LineDetailsInvoices selectedLineId={lineDetailsSelected?.id} contentHeight={itemTableHeight} />
              </Form.TabContent>
              <Form.TabContent
                id={'traceability'}
                label={'Traceability'}
                key={'traceability'}
                onlyRenderWhenActive={true}
              >
                <TraceabilityDetails
                  salesOrderLine={lineDetailsSelected as ISalesOrderLine}
                  contentHeight={itemTableHeight}
                />
              </Form.TabContent>
            </Form.TabPanel>
          </Form.TabContent>
          <Form.TabContent
            id="archived"
            label="Archived"
            key="archived"
            shouldRender={isNotNew}
            onlyRenderWhenActive={true}
          >
            <LazySalesOrderLineWorkspace
              embeddedView={true}
              allowView={false}
              columnData={[...DISPATCH_DETAIL_FIELD_NAMES, 'archivedType']}
              initialSortColumn={props.values?.linesSortColumn || 'lineOrder'}
              initialSortDir={props.values?.linesSortDirection || 'ASC'}
              predefinedFilters={[
                {
                  filterOperation: 'EQUALS',
                  filterParameters: {
                    field: 'archived',
                    value: 'true',
                  },
                },
                ...eventPredefinedFilters,
              ]}
              noEdit={true}
              viewScreenName={'Orders/ArchivedLines'}
              contentHeight={itemTableHeight}
            />
          </Form.TabContent>
          <Form.TabContent
            id="audit"
            label="Audit"
            key="audit"
            shouldRender={isNotNew && !salesOrderArchivedAndAmazon}
            onlyRenderWhenActive={true}
          >
            <GridContainer>
              <AuditByFieldWorkspace
                embeddedView={true}
                predefinedFilters={salesOrderAuditPredefinedFilters}
                viewScreenName="/sales/SalesOrderAudit/Workspace"
                entity={entities.SalesOrderAuditByField}
              />
            </GridContainer>
          </Form.TabContent>
          <Form.TabContent
            id="instructionLines"
            label="Delivery Instructions"
            key="instructionLines"
            onlyRenderWhenActive={true}
          >
            <DeliveryInstructionsTab {...props} />
          </Form.TabContent>
          <Form.TabContent
            id="payments"
            label="Payments"
            key="payments"
            shouldRender={orderType === 'ORDER'}
            onlyRenderWhenActive={true}
          >
            <>
              {payments.filter((payment) => payment?.paymentPrinted).length === 0 ? null : (
                <>
                  <DocumentModal2
                    key={Payment.title}
                    entity={Payment}
                    reprint={true}
                    multiValue={true}
                    modalWrapper={true}
                    modalOpen={paymentReprintModalOpen}
                    onClose={() => setPaymentReprintModalOpen(false)}
                    values={values}
                  />
                  <InfoButton onClick={() => setPaymentReprintModalOpen(true)}>Reprint Payment Receipts</InfoButton>
                </>
              )}
              {paymentLines?.length !== 0 ? (
                <SortableDataGrid
                  listData={paymentLines}
                  rowsCount={paymentLines.length || 0}
                  columns={definePaymentHistoryColumnMeta()}
                  enableCellSelect={false}
                  addBlankRow={false}
                  autoContentHeight={true}
                  filterable={false}
                />
              ) : null}
            </>
          </Form.TabContent>
          <Form.TabContent
            id="salesOrdersFromQuote"
            label="Sales Orders"
            shouldRender={orderType === OrderType.Quote && props.values?.id}
            onlyRenderWhenActive={true}
          >
            <LazySalesOrderWorkspace
              embeddedView={true}
              enableRowSelect={true}
              fieldNames={['orderNumber', 'orderReference', 'orderDate', 'nettGoodsTotal', 'salesOrderStatus']}
              predefinedFilters={[
                { filterOperation: FilterOperation.Equals, filterParameters: { field: 'originalOrderId', value: id } },
              ]}
              viewScreenName={'/Sales/OrdersFromQuote'}
            />
          </Form.TabContent>
          <Form.TabContent
            id="exchanges"
            label="Exchanges"
            key="exchanges"
            shouldRender={values.exchangeCredits && values.exchangeCredits.length > 0}
            onlyRenderWhenActive={true}
          >
            <Legend
              label={'Exchange Credits'}
              description={'Note - Exchange lines can only be added via the Trade Counter form.'}
            />
            <Form.Field<IEditableDataGridProps>
              dataid="exchangeCredits"
              component={EditableDataGrid}
              columns={EXCHANGE_COLUMN_META}
            />
          </Form.TabContent>
        </Form.TabPanel>
      </Form.Form>
    </Form.FormContainer>
  );
};

//Using a wrapper in order to use hooks for special order product queries.
//TODO - Could potentially move the formQuery/config queries into here as hooks, but need to be careful with DocumentConfig due to usage in createForm().
const SalesOrderFormWrapper = (props: {
  values: ISalesOrder;
  change: Function;
  paymentModalState: { modalOpen: false };
  setPaymentModalState: (newState: { modalOpen: false }) => void;
}) => {
  const dispatch = useDispatch();
  const [alternateProductState, setAlternateProductState] = useState<{
    modalOpen: boolean;
    modalRowIdx?: number;
    short: number;
  }>({
    modalOpen: false,
    short: 0,
  });
  const [productModalState, setProductModalState] = useState({ modalOpen: false });
  const [returnOrderModalState, setReturnOrderModalState] = useState({ modalOpen: false });
  const appContext = useContext(AppContext);
  const userContext = useContext(UserContext);

  const [stockTotalQuery] = useLazyQuery<IStockTotalQueryResult, IStockTotalQueryVariables>(StockTotalQuery);

  const { specialOrderProductState, setSpecialOrderProductState, createSpecialOrderProduct } =
    useSpecialOrderProductState();

  const { productFromLuckinsItemState, setProductFromLuckinsItemState, createProductFromLuckinsItem } =
    useProductFromLuckinsItemState();

  const { baseValues, change, reloadData } = useContext(ConnectedFormContext);
  const baseOrderLines = useMemo(() => baseValues?.orderLines ?? [], [baseValues?.orderLines]);

  const checkShortageOrAlternateModal = useCallback(
    (commit: ICommit<ISalesOrderLine>) => {
      const { updated, rowIdx, original, cellKeys } = commit;

      if (!original) {
        return;
      }

      if (
        (updated?.product && !updated.product.leveled) ||
        userContext.currentUser.companyUser.companyUserSalesOptions?.shortagePromptBehaviour !==
          SalesOrderPromptBehaviour.PromptOnSaveAndLineEntry
      ) {
        return;
      }

      const variables = defineStockTotalQueryVariables(updated as ISalesOrderLine, props.values.warehouse?.id);

      //Get latest shortage processed state (If it can't be found, assume it's required).
      const shortageProcessedState =
        updated?.shortageProcessedState ?? original?.shortageProcessedState ?? ShortageProcessedState.Required;
      if (shortageProcessedState !== ShortageProcessedState.Required) {
        return;
      }

      // if product id and warehouse id set, fetch the stock total
      if (variables.productId && variables.warehouseId) {
        stockTotalQuery({ variables }).then(({ data }) => {
          const stockTotal = data?.data;
          if (!stockTotal || !updated) return;

          const id = updated.id;
          const thisLine = id && baseOrderLines.find((line: ISalesOrderLine) => line.id === id);
          let short: number;

          // In order to reach a short quantity that takes alternate selling units into account, need to calculate
          // standard unit quantity based on quantity (standard unit quantity on the line is not yet up-to-date)
          let newStandardUnitQuantity = parseFloat(updated.quantity);
          const activeSellingUnit = updated.activeSellingUnit;
          if (activeSellingUnit) {
            if (activeSellingUnit.factorDirection === 'FROM_BASE_UNIT') {
              newStandardUnitQuantity = parseFloat(updated.quantity) * activeSellingUnit.quantityFactor;
            } else {
              newStandardUnitQuantity = parseFloat(updated.quantity) / activeSellingUnit.quantityFactor;
            }
          }

          if (thisLine) {
            const originalQuantity = thisLine.standardUnitQuantity;
            const outstanding = original?.outstanding ?? originalQuantity;
            short = Math.max(outstanding - originalQuantity + newStandardUnitQuantity, 0);

            short = round(short, RoundingModes.NEAREST, (thisLine as ISalesOrderLine).quantityPrecision ?? 2);
          } else {
            short = newStandardUnitQuantity;
          }

          // if we have a quantity check the free stock and whether the product is obsolete
          const orderType = props.values.orderType;
          const reviewShortagesLater =
            props.values.reviewShortagesLater ||
            props.values.salesOrderActivationType === SalesOrderActivationType.Scheduled;
          const draftAssembly = updated?.draftAssemblyId && updated?.product?.productClass === ProductClass.Assembly;
          //do not consider makeable for assemblies
          const free =
            stockTotal.freeStock +
            (stockTotal.product?.productClass === ProductClass.Assembly ? 0 : stockTotal.makeable);
          if (
            (orderType !== 'QUOTE' && !reviewShortagesLater && !draftAssembly && free < short) ||
            stockTotal.product?.obsolete
          ) {
            // Flag that this line has had the modal displayed
            dispatch(
              change(`orderLines.${commit.rowIdx}.shortageProcessedState`, ShortageProcessedState.ProcessedLine)
            );
            //Set this to avoid any obscure timing issue (This same commit 'could' be setting it to 'Required' and if the change above
            //completed first, it could result in a reset).
            updated.shortageProcessedState = ShortageProcessedState.ProcessedLine;

            // show the alternative product modal
            setAlternateProductState({
              modalOpen: true,
              modalRowIdx: rowIdx,
              short,
            });
          } else if (draftAssembly) {
            // if we have a draft assembly then the change will be processed on the draft assembly
            dispatch(
              change(`orderLines.${commit.rowIdx}.shortageProcessedState`, ShortageProcessedState.ProcessedLine)
            );
          }
        });
      }
    },
    [
      baseOrderLines,
      change,
      dispatch,
      props.values.orderType,
      props.values.reviewShortagesLater,
      props.values.salesOrderActivationType,
      props.values.warehouse?.id,
      stockTotalQuery,
      userContext.currentUser.companyUser.companyUserSalesOptions?.shortagePromptBehaviour,
    ]
  );

  const onRowUpdated = useSalesOrderOnRowUpdated(
    alternateProductState.modalOpen,
    checkShortageOrAlternateModal,
    createProductFromLuckinsItem,
    createSpecialOrderProduct
  );

  const salesOrderContext = useMemo<SalesOrderContextType>(() => {
    return {
      onRowUpdated,
      setReturnOrderModalState,
      createSpecialOrderProduct,
    } as SalesOrderContextType;
  }, [createSpecialOrderProduct, onRowUpdated]);

  return (
    <>
      <ConnectedFormPristinePrompt />
      <CurrencyContext.Provider value={{ currency: props.values?.currency }}>
        <SalesOrderContext.Provider value={salesOrderContext}>
          <ModalContext.Provider value={{ onClose: () => props.setPaymentModalState({ modalOpen: false }) }}>
            <SalesOrderPaymentModal
              isOpen={props.paymentModalState.modalOpen}
              orderId={props.values?.id}
              billingAddress={props.values?.customer?.address}
              emailAddress={props.values?.customer?.email}
              warehouseId={props.values?.warehouse?.id}
            />
          </ModalContext.Provider>
          <SalesCreditFormModal
            modalState={returnOrderModalState}
            closeModal={() => {
              //Reload form data, since the credit may have made changes to the order or order lines & hence changed the concurrency version (So a subsequent save may throw a conflict resolution error).
              reloadData?.(true);
              setReturnOrderModalState({ modalOpen: false });
            }}
          />
          <SalesOrderProductSaveModal
            modalState={specialOrderProductState}
            closeModal={() => {
              setSpecialOrderProductState({ modalOpen: false });
            }}
            specialOrder={true}
          />
          <SalesOrderProductSaveModal
            modalState={productFromLuckinsItemState}
            closeModal={() => {
              setProductFromLuckinsItemState({ modalOpen: false });
            }}
            miniForm={false}
            luckins={true}
          />
          {alternateProductState.modalRowIdx !== null && alternateProductState.modalRowIdx !== undefined ? (
            <SalesOrderAlternativeProductsModal
              showModal={alternateProductState.modalOpen && !productModalState.modalOpen}
              closeModal={() => {
                setAlternateProductState({ ...alternateProductState, modalOpen: false });
              }}
              formChange={(field, value) => {
                dispatch(props.change(field, value));
              }}
              salesOrder={props.values}
              short={alternateProductState.short}
              rowIdx={alternateProductState.modalRowIdx}
            />
          ) : null}
          <SalesOrderForm
            {...props}
            onRowUpdated={onRowUpdated}
            checkShortageOrAlternateModal={checkShortageOrAlternateModal}
            setProductModalState={setProductModalState}
            app={appContext}
            itemGridIgnoreKeypresses={
              productModalState.modalOpen ||
              alternateProductState.modalOpen ||
              returnOrderModalState.modalOpen ||
              specialOrderProductState.modalOpen ||
              productFromLuckinsItemState.modalOpen
            }
          />
        </SalesOrderContext.Provider>
      </CurrencyContext.Provider>
    </>
  );
};

export function createSalesForm(entity: EntityType & { idParam?: string }) {
  const { default: defaultQuery, temporarySave, formTitle, instance, update, fragment, type, idParam = 'id' } = entity;

  const SalesForm = createForm({
    form: type,
    name: formTitle,
    entity: entity,
    queryFragment: fragment,
    getSubmitValues: submitSalesOrderValues,
    forceUpdate: true,
    defaultReturnUrl: entity.workspaceUrl,
  })(SalesOrderFormWrapper);

  return (props: any) => {
    const formProps = useSelector((store) => mapStateToFormProps(store, props));

    const url = props.match?.url || '';
    let customerId = props.match?.params?.customerid;
    let isTemplate = url.startsWith('/Sales/Order/Template');
    const isQuote = url.startsWith('/Sales/Quote/Details/New');
    let orderType = isQuote ? 'QUOTE' : null;

    (props.history?.location?.state as ISalesOrderLocationState)?.defaultValues?.forEach?.(
      (defaultValue: { field: string; value: any }) => {
        if (defaultValue.field === 'orderType') {
          orderType = defaultValue.value;
        } else if (defaultValue.field === 'templated') {
          isTemplate = defaultValue.value;
        } else if (!customerId && defaultValue.field === 'customerId') {
          customerId = defaultValue.value;
        } else {
          console.warn('Unhandled default field.');
        }
      }
    );
    const defaultVariables = { customerId: customerId, template: isTemplate, orderType: orderType };

    const formDefault = useFormQuery({ default: defaultQuery, instance: instance } as EntityType, {
      duplicate: true,
      overrideParams: props.match?.params,
      idParam,
      defaultVariables,
    });
    const cacheUpdate = useEntityCacheUpdate('salesOrders', 'salesOrder', { detailView: props.detailView });
    const [formUpdate] = useMutation(update!, {
      update: cacheUpdate,
      refetchQueries: [
        SalesOrderLine.workspace!,
        StockTotalQuery,
        SalesNotesWorkspaceQuery,
        CustomerNotesWorkspaceQuery,
      ],
    });
    const [formTemporaryUpdate] = useMutation(temporarySave!);
    const dispatch = useDispatch();

    //TODO - Remove the wrapping of '{data:??}' from the below definition for these 4 configs.
    const documentConfig = useDocumentConfig();
    const salesOrderConfig = useSalesOrderConfig();
    const customerConfig = useCustomerConfig();
    const productConfig = useProductConfig();
    const company = useCompany();

    //This useEffect triggers a new default record to be created when randomKey changes in location state.
    //E.g. When creating multiple orders sequentially via the Customer Form.
    const randomKey = props.location?.state?.randomKey;
    const [lastKey, setLastKey] = useState(null);
    useEffect(() => {
      if (lastKey && randomKey && lastKey !== randomKey) {
        formDefault.refetch().then(() => {});
      } else {
        setLastKey(randomKey);
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [randomKey]);

    const [paymentModalState, setPaymentModalState] = useState<{
      modalOpen: boolean;
    }>({ modalOpen: false });

    //Need to define custom prompt handlers at this level so they're available in ConnectedForm.
    //But the actual payment modal needs to go at a lower level so it can access ConnectedFormContext.
    const customPromptHandlers = {
      'confirmationResponses.OrderConfirmation:CASH_TO_BE_RECEIVED': {
        Payment: () => {
          setPaymentModalState({ modalOpen: true });
        },
      },
    };

    const salesOrderPostSave = useSalesOrderPostSave();
    const purchaseOrderPrintOnSuccess = usePurchaseOrderPrintOnSuccess();

    return (
      <SalesForm
        {...formProps}
        {...props}
        formUpdate={formUpdate}
        formTemporaryUpdate={formTemporaryUpdate}
        formData={formDefault}
        dispatch={dispatch}
        documentConfig={{ data: documentConfig }}
        salesOrderConfig={{ data: salesOrderConfig }}
        productConfig={{ data: productConfig }}
        customerConfig={{ data: customerConfig }}
        company={company}
        customPromptHandlers={customPromptHandlers}
        paymentModalState={paymentModalState}
        setPaymentModalState={setPaymentModalState}
        postSaveFunction={salesOrderPostSave.postSaveFunction}
        addModalActions={salesOrderPostSave.addModalActions}
        onSubmitSuccess={(result?: ISalesOrder) => {
          purchaseOrderPrintOnSuccess(result);
        }}
      >
        {salesOrderPostSave.modals}
      </SalesForm>
    );
  };
}

export const SalesOrderFormByAllocation = createSalesForm({
  ...SalesOrder,
  instance: instanceByAllocationQuery,
  idParam: 'allocationId',
});

export default createSalesForm(entities.SalesOrder);
